import { NgClass } from "@angular/common";
import { Component, ElementRef, Injector, NgZone, OnInit, Renderer2, ViewChild, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from "@angular/material/tooltip";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { canonicalizeProsubQueryParams, resolveProsubIdFromParamMap } from "@core/prosub-query-params";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { ErrorHandlerService } from "@core/ErrorHandlerService/error-handler.service";
import { PartialRegistrationService } from "@core/PartialRegistrationService/partial-registration.service";
import { CreateUser } from "@interfaces/create-user.i";
import { FlagInterface, Language, allLanguageCodes, defaultLanguage } from "@interfaces/translation-interface";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import {
  FirebaseUISignInFailure,
  FirebaseUISignInSuccessWithAuthResult,
  FirebaseuiAngularLibraryComponent,
} from "firebaseui-angular";
import * as moment from "moment";
import { BehaviorSubject, Observable, Subject, Subscription, firstValueFrom, interval, merge, of, throwError } from "rxjs";
import { catchError, filter, map, switchMap, take, takeUntil, timeout } from "rxjs/operators";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { ForgotPasswordPage } from "src/app/components/forgot-password/forgot-password.page";
import { ResetPasswordPopupComponent } from "src/app/components/reset-password-popup/reset-password-popup.component";
import { TermsAndPolicyComponent } from "src/app/components/terms-and-policy/terms-and-policy.component";
import { VerifyPhoneNumberComponent } from "src/app/components/verify-phone-number/verify-phone-number.component";
import { ConnectionManagerService } from "src/app/services/ConnectionManager/connection-manager.service";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { LoginDataResolverService } from "src/app/services/login-data-resolver.service";
import { RegistrationDefaults, registrationDefaults } from "./registration-defaults";
import { UserManagementService } from "src/app/services/user-management.service";
import { environment } from "src/environments/environment.prod";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";
import { PreferenceComponent } from "../../account/edit-account/preference/preference.component";
import { SafeLocalStorageService } from "src/app/services/safe-local-storage.service";
import { CommonService } from "src/app/services/common/common.service";
import { ToastFacadeService } from "src/app/core/toast-facade.service";
import { ClarityService } from "src/app/services/clarity.service";
import { PosthogService } from "src/app/services/posthog.service";
import { ResourceLoaderService } from "src/app/services/resource-loader.service";
import { SalesJourneyIdentityService } from "src/app/services/sales-journey-identity.service";
declare let document;
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 10000000,
  touchendHideDelay: 100000,
};
declare global {
  interface Window {
    onloadTurnstileCallback: () => void;
    turnstile: any;
    _turnstileState: {
      widgetId: number | null;
      token: string | null;
      initialized: boolean;
      scriptReady?: boolean;
      containerElement?: HTMLElement;
      siteKey?: string;
      onTokenCallback?: (token: string) => void;
      initializeTurnstile?: () => void;
    };
    // Android bridge is now handled globally by android-bridge-polyfill.js
    Android?: {
      showHTML?: (html: string) => void;
      setContactAutofillValuesFromBridge?: (values: any) => void;
      [key: string]: any;
    };
  }
}
declare const turnstile: any;

@Component({
  selector: "app-partial-registration",
  templateUrl: "./partial-registration.component.html",
  styleUrls: ["./partial-registration.component.scss", "../onesignal.scss"],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }],
  animations: [bounceIn],
  standalone: true,
  imports: [
    IonicModule,
    FirebaseuiAngularLibraryComponent,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatProgressSpinner,
    MatIcon,
    SafeHtmlPipe,
    TranslatePipe,
  ],
})
export class PartialRegistrationComponent implements OnInit {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private bottomSheet = inject(MatBottomSheet);
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  public translate = inject(TranslateService);
  private GTMServise = inject(GTMSagmentService);
  private matDialog = inject(MatDialog);
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private GTMService = inject(GTMSegmentService);
  private ngZone = inject(NgZone);
  private AuthPartialRegService = inject(AuthPartialRegService);
  private userManagementService = inject(UserManagementService);
  private errorHandlerService = inject(ErrorHandlerService);
  private partialRegistrationHelperService = inject(PartialRegistrationService);
  private connectionManagerService = inject(ConnectionManagerService);
  private safeLocalStorage = inject(SafeLocalStorageService);
  private commonService = inject(CommonService);
  private toastFacadeService = inject(ToastFacadeService);
  private clarityService = inject(ClarityService);
  private posthogService = inject(PosthogService);
  private resourceLoader = inject(ResourceLoaderService);
  private salesJourneyIdentityService = inject(SalesJourneyIdentityService);
  private loginDataResolver = inject(LoginDataResolverService);
  private cancelCheckoutSdkPreload?: () => void;
  private checkoutSdkPreloadStarted = false;


  private readonly DEFAULT_ENGLISH_LANG = {
    language_code: "en",
    language_name: "English",
    language_status: true,
    selected: true,
    country_code: "44",
    name: "English"
  };
  // Track selection sources for analytics
  languageSource: 'url' | 'storage' | 'browser' | 'ip' | 'default' = 'default';
  currencySource: 'url' | 'storage' | 'browser' | 'language' | 'default' | 'ip' = 'default';
  enhancementsLoading = false;
  analyticsReady = false;
  private readonly DEFAULT_GBP_CURRENCY = {
    currency_code: "GBP",
    currency_name: "British Pound",
    status: true,
    selected: true,
    country_code: "44",
    currency_symbol: "£",
    currency_symbol_encoding: "pound;",
    "3ds_status": true
  };

  isSpoofMsn: boolean;
  uid: string;
  resetToken: string;
  passwordType = "password";
  passwordIcon = "eye";
  createAccountForm: FormGroup;
  sub: Subscription;
  timer$: any;
  toolTipText;
  translatedToastMsg: any;
  cell1TelInput = {
    initialCountry: CommonVariable.countryCode,
    separateDialCode: true,
  };
  spinnerAnimation: boolean;
  progressBar: number;
  proceed: boolean = true;
  languageArray: any[] = [];
  showMSN: boolean = true;
  showVoucher: boolean = false;
  showEmail: boolean = true;
  showDob: boolean = false;
  showTerms: boolean = true;
  dobDate: string;
  maxDateOfBirth: string;
  defaultDateOfBirth: string;
  isDateModalOpen: boolean = false;
  @ViewChild("phoneNumberInput", { static: true }) phoneNumberInput: ElementRef;
  phoneInValid: boolean;
  socialLogin = false;
  alternateOptMsgBasedOn4x = false;
  isShowDiv: Boolean = true;
  language = [];
  currencyArray: any[] = [];
  ipBasedUserLanguage: Language;
  ipBasedUserCurrency: string;
  private ipDataCache: any = null;
  private ipDataFetchPromise: Promise<any> | null = null;
  callFromPromotion: string;
  gc: string;
  private queryParamsSubscription: Subscription;
  private prosubDetailsSubscription: Subscription;
  private selectedlanguageSubscription: Subscription;
  private constantsMsgSubscription: Subscription;
  private userDetailsSubscription: Subscription;
  private wrongPasswordSubscription: Subscription;
  private incorrectAttemptSubscription: Subscription;
  private activeCurrencyListSubscription: Subscription;
  private loadLanguageDataSubscription: Subscription;
  private loadCurrencyDataSubscription: Subscription;
  selectedFlag: any;
  prosub_id: any;
  default_prosub_id: any;
  isOnline: boolean = true;
  flag: FlagInterface[] = [
    { id: "1", country_code: Language.English, name: "English (default)", img: "../../../assets/images/kingdom.png" },
    { id: "2", country_code: Language.Italian, name: "Italiana", img: "../../../assets/images/italian.png" },
    { id: "3", country_code: Language.German, name: "Deutsche", img: "../../../assets/images/deuch.jpg" },
    { id: "4", country_code: Language.French, name: "Français", img: "../../../assets/images/france.png" },
    { id: "5", country_code: Language.Spanish, name: "Españo la", img: "../../../assets/images/spain.png" },
  ];
  loaded: boolean;
  vc: string;
  tp1: string;
  tp2: string;
  tp3: string;
  upsell_ID: string;
  t_id: string;
  other: any;
  pt: string;
  cje: any;
  selectedLanguage: string;
  selectedCurrency: string;
  wrongPassword$ = new BehaviorSubject(false);
  incorrectAttempt$ = new BehaviorSubject(false);
  msn: any;
  countryCode: any;
  incorrectPhoneNumber: any = false;
  phoneNumberAttempt: String;
  wrongPassword: number;
  incorrectAttempts: number;
  blocklogin: Date = null;
  prosubOfferId: number;
  prosubPrice: number;
  prosubIntPrice: Data;
  wrongLoginAttempt: number;
  wrongCredentialMatched: boolean;
  isSameLoginTime: boolean;
  dialCode: string;
  private unsubscribe$ = new Subject<void>();
  newPhoneNumber: string;
  newDialCode: string;
  landingPageData = '';
  ipstackCountryCode: string;
  languageParamState = false;
  private destroy$ = new Subject<void>();
  /** Set in ngOnDestroy; prefer this over destroy$.closed (complete() does not set closed). */
  private destroyed = false;
  private readonly EMAIL_PATTERN = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
  isLoading = true;
  loadingError = false;
  errorMessage = '';
  offerState: 'loading' | 'ready' | 'error' = 'loading';
  offerError = '';
  private offerBaseCurrency = 'GBP';
  private initialDefaults?: RegistrationDefaults;
  private pendingIpCurrency = '';
  private userSelectedLanguage = false;
  private userSelectedCurrency = false;
  // Turnstile properties
  turnstileSiteKey: string = environment.turnstile?.siteKey || '';
  turnstileEnabled: boolean = environment.turnstile?.enabled || false;
  private turnstileWidgetId: string | null = null;
  private turnstileToken: string | null = null;
  private turnstileReady: boolean = false;
  private turnstileInitPromise: Promise<void> | null = null;
  @ViewChild('turnstileContainer', { static: false }) containerRef!: ElementRef;

  private readonly LANGUAGE_CURRENCY_TO_DIAL_CODE = {
    en_GBP: "+44",
    en_USD: "+1",
    en_AUD: "+61",
    en_CAD: "+1",
    en_NZD: "+64",
    en_ZAR: "+27",
    en_INR: "+91",

    fr_EUR: "+33",
    fr_CAD: "+1",
    fr_CHF: "+41",

    de_EUR: "+49",
    de_CHF: "+41",
    de_ATS: "+43",

    es_EUR: "+34",
    es_MXN: "+52",
    es_ARS: "+54",
    es_COP: "+57",

    it_EUR: "+39",
    it_CHF: "+41",

    pt_EUR: "+351",
    pt_BRL: "+55",

    en: "+44",
    fr: "+33",
    de: "+49",
    es: "+34",
    it: "+39",
    pt: "+351",

    EUR: "+49",
    USD: "+1",
    GBP: "+44",
  };

  smartDefaultDialCode: string;
  userModifiedDialCode: boolean;

  constructor(
    private injector: Injector,


  ) {
    // Keep the constructor minimal: only synchronous field assignments and
    // query-param reads. All RxJS subscriptions and async work are started in
    // ngOnInit to avoid exhausting the WebKit call stack during class
    // instantiation (which caused RangeError: Maximum call stack size exceeded
    // and the secondary "Error: fa" on iPhone / Chrome Mobile iOS).
    this.AuthPartialRegService.normalizeQueryParams();
    this.uid = "";
    const blockLoginStr = this.safeLocalStorage.getItem("blocklogin");
    this.blocklogin = blockLoginStr ? new Date(blockLoginStr) : null;
    this.languageArray = [this.DEFAULT_ENGLISH_LANG];
    this.currencyArray = [this.DEFAULT_GBP_CURRENCY];
    this.isLoading = true;
    this.wrongLoginAttempt = 0;
    this.wrongCredentialMatched = false;

    const queryParams = this.route.snapshot.queryParams;
    this.tp1 = queryParams.tp1 ?? null;
    this.tp2 = queryParams.tp2 ?? null;
    this.tp3 = queryParams.tp3 ?? null;
    this.other = queryParams.other ?? null;
    this.pt = queryParams.pt ?? null;
  }

  /**
   * Set up all RxJS subscriptions that were previously in the constructor.
   * Idempotent: clears any previously installed view subscriptions first so
   * ngOnInit + ionViewWillEnter (or repeated enter after leave) cannot stack duplicates.
   */
  private initSubscriptions(): void {
    this.clearViewSubscriptions();

    this.selectedlanguageSubscription = this.authService.selectedlanguage$
      .pipe(
        takeUntil(this.destroy$),
        catchError(err => {
          try {
            this.errorHandlerService?.logError?.('Language subscription error', err);
          } catch {
            // Logging must remain non-throwing
          }
          return of(defaultLanguage);
        })
      )
      .subscribe(
        (l) => {
          this.selectedLanguage = l;
          if (this.flag.find((flag) => flag?.country_code === l)) {
            this.cell1TelInput.initialCountry = l != defaultLanguage ? l : CommonVariable.countryCode;
          }
          const finalLanguage = l ? l : defaultLanguage;
          this.translate.use(finalLanguage);
          const prevLocalLang = this.safeLocalStorage.getItem("language_code") || "";
          this.userManagementService.setUserLanguageLogInFb(prevLocalLang, finalLanguage, "partial-reg ngOnInit");
          this.safeLocalStorage.setItem("language_code", finalLanguage);
        },
        (err) => {
          return err;
        }
      );

    this.constantsMsgSubscription = this.authService.getConstantsMsg$
      .pipe(
        takeUntil(this.destroy$),
        catchError(err => {
          try {
            this.errorHandlerService?.logError?.('Constants message subscription error', err);
          } catch {
            // Logging must remain non-throwing
          }
          return of({});
        })
      )
      .subscribe((msg: Data) => {
        this.translatedToastMsg = msg?.static_messages_pwa;
      });

    this.userDetailsSubscription = this.authService.userDetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (user) => {
          try {
            if (user)
              user.language_code = this.authService?.selectedlanguage$?.value ?? defaultLanguage;
          } catch (err) {
            try {
              this.errorHandlerService?.logError?.('User details subscription next error', err);
            } catch {
              // Logging must remain non-throwing
            }
          }
        },
        error: (err) => {
          try {
            this.errorHandlerService?.logError?.('User details subscription error', err);
          } catch {
            // Logging must remain non-throwing
          }
        },
      });

    // Handle errors in the subscriber (not via catchError+of) so a transient
    // failure does not complete wrongPassword$/incorrectAttempt$ permanently.
    this.wrongPasswordSubscription = this.wrongPassword$.pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (msg: boolean) => {
        try {
          if (msg) {
            if (this.phoneNumberAttempt != this.createAccountForm.get("phoneNumber").value) {
              this.phoneNumberAttempt = this.createAccountForm.get("phoneNumber").value;
              this.wrongPassword = 1;
            } else {
              this.wrongPassword++;
            }
            if (this.wrongPassword > 1) {
              this.openForgetPassword();
            }
          }
        } catch (err) {
          try {
            this.errorHandlerService?.logError?.('Wrong password subscription error', err);
          } catch {
            // Logging must remain non-throwing
          }
        }
      },
      error: (err) => {
        try {
          this.errorHandlerService?.logError?.('Wrong password subscription error', err);
        } catch {
          // Logging must remain non-throwing
        }
      },
    });

    this.incorrectAttemptSubscription = this.incorrectAttempt$.pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (msg: boolean) => {
        try {
          if (msg) {
            if (!this.incorrectAttempts) this.incorrectAttempts = 1;
            else this.incorrectAttempts++;
            if (this.incorrectAttempts > 4) {
              this.blocklogin = new Date();
              this.safeLocalStorage.setItem("blocklogin", this.blocklogin.toISOString());
            }
          }
        } catch (err) {
          try {
            this.errorHandlerService?.logError?.('Incorrect attempt subscription error', err);
          } catch {
            // Logging must remain non-throwing
          }
        }
      },
      error: (err) => {
        try {
          this.errorHandlerService?.logError?.('Incorrect attempt subscription error', err);
        } catch {
          // Logging must remain non-throwing
        }
      },
    });
  
    this.turnstileEnabled = this.isTurnstileCanaryRoute(this.route.snapshot.queryParams);
  }

  async ngOnInit() {
    // Mark view active so in-flight async continuations can detect ionViewWillLeave().
    this.isViewActive = true;

    // Start subscriptions here (not in the constructor) to keep the constructor
    // synchronous and shallow, preventing call-stack overflow on WebKit/iPhone.
    // Subscriptions are set up synchronously first so that no BehaviorSubject
    // emission or route event is missed during the yield below.
    this.initSubscriptions();

    // New registration journey entry — do not retain a prior user's SQL customer_id.
    this.authService.resetRegistrationIdentityCache();
    // Generate journey_id once at registration entry (preserved through checkout/payment).
    this.salesJourneyIdentityService.startNewSalesJourney();
    // Warm localStorage.ip early so Turnstile submit can skip a blocking geo-IP wait.
    this.authService.warmRegistrationIpCache();

    // PHASE 1: Critical initialization (max 500ms)
    await this.runCriticalInitialization();
  }

  /**
   * Restartable critical init path shared by ngOnInit and ionViewWillEnter.
   * Safe to call again after an Ionic cache leave aborted a prior attempt mid-yield.
   */
  private async runCriticalInitialization(): Promise<void> {
    // Set loading guard state before anything else so that subscription handlers
    // installed above can safely check isLoading during the macrotask yield.
    this.isLoading = true;
    this.loadingError = false;
    this.errorMessage = '';

    try {
      // Yield so that Angular's component-instantiation + ngOnInit call stack is
      // fully unwound before heavy initialisation begins. The combined depth of
      // Angular DI + constructor + initSubscriptions + initializeCriticalData was
      // enough to exceed WebKit's (iPhone) shallower stack limit, surfacing as the
      // minified "Error: pa" / "Error: fa" / "Error: Ca" RangeError. BehaviorSubjects
      // replay their latest value to late subscribers, so no emissions are missed.
      await new Promise<void>(resolve => setTimeout(resolve, 0));
      if (this.destroyed || !this.isViewActive) {
        // Leave may have aborted mid-yield; ask ionViewWillEnter to retry.
        this.needsInitRestart = true;
        return;
      }

      // PHASE 1: Critical initialization (max 500ms)
      await this.initializeCriticalData();

      if (!this.destroyed && this.isViewActive && !this.loadingError) {
        this.initCompleted = true;
        this.needsInitRestart = false;
      } else if (!this.isViewActive && !this.destroyed) {
        this.needsInitRestart = true;
      }
    } catch (error) {
      this.errorHandlerService.logError('Critical initialization error', error);
    } finally {
      // Always clear loading — including when we abort after leave — so a cached
      // page cannot stick on a permanent spinner when the user navigates back.
      this.isLoading = false;
      if (this.isViewActive && !this.destroyed) {
        // Tell the index.html instant loader to step down now that the form (or the
        // error UI) is ready to paint. Deferred a tick so Angular renders it first,
        // preventing any blank frame between the loader and the form.
        this.signalPartialRegReady();
      }
    }

    // PHASE 2: Background loading (non-blocking) — only when form init succeeded
    // and the view is still on screen.
    if (!this.loadingError && this.isViewActive && !this.destroyed) {
      this.loginDataResolver.partialRegistrationOffer$
        .pipe(takeUntil(this.destroy$))
        .subscribe(state => this.applyOfferState(state));
      this.loadEnhancementsInBackground();
    }
  }

  /**
   * Notifies the index.html instant loader that the registration view is ready, so it
   * can be removed. Runs in NgZone-safe setTimeout(0) to allow the form to render first.
   */
  private signalPartialRegReady(): void {
    try {
      setTimeout(() => {
        try {
          window.dispatchEvent(new CustomEvent('ls:partial-reg-ready'));
        } catch {
          // Ignore - the index.html safety timeout will remove the loader.
        }
      }, 0);
    } catch {
      // Non-fatal.
    }
  }

  private async initializeCriticalData(): Promise<void> {
    const urlParams = this.route.snapshot.queryParams;
    const browserLanguages = typeof navigator !== 'undefined' && navigator.languages?.length
      ? navigator.languages
      : (typeof navigator !== 'undefined' ? [navigator.language] : []);
    this.initialDefaults = registrationDefaults(urlParams, browserLanguages);
    this.selectedLanguage = this.initialDefaults.language;
    this.selectedCurrency = this.initialDefaults.currency;
    this.languageSource = Object.keys(urlParams || {}).some(key =>
      ['lang', 'language'].includes(key.toLowerCase())) ? 'url' :
      (this.initialDefaults.browserRegion ? 'browser' : 'default');
    this.currencySource = this.initialDefaults.hasUrlCurrency ? 'url' :
      (this.initialDefaults.browserRegion ? 'browser' : 'default');

    // Yield to the event loop BEFORE form initialization so that WebKit's call
    // stack fully unwinds first. Without this early yield the combined depth of
    // ngOnInit → initializeCriticalData → initializeFormWithDefaults (plus all
    // injected service calls inside it) exceeds WebKit's shallower stack limit
    // on iPhone, causing "RangeError: Maximum call stack size exceeded"
    // (surfaced as the minified "Error: Ca" / "Error: fa" / "Error: ia" in
    // production bundles). By yielding here, form initialization always starts
    // as a fresh task with minimal stack depth.
    await new Promise<void>(resolve => setTimeout(resolve, 0));

    // Component may have been destroyed or left during the yield (Ionic cache).
    if (this.destroyed || !this.isViewActive) {
      return;
    }

    // Initialize form with synchronous defaults in a fresh call-stack frame.
    // Wrapped in try/catch so any residual WebKit call-stack overflow is
    // caught and reported rather than propagating as an unhandled exception.
    try {
      // initializeFormWithDefaults is now async: it contains its own internal
      // setTimeout(0) yield to split heavy calls (onLanguageChange,
      // validateLoginForm) into a separate stack frame, preventing the WebKit
      // call-stack overflow seen as "Error: La" / "Error: fa" / "Error: Ca".
      await this.initializeFormWithDefaults();
    } catch (error) {
      this.errorHandlerService.logError('Form initialization error', error);
      // Do not continue into loadCriticalData with a half-initialized form —
      // surface the existing loadingError / Retry UI instead.
      this.loadingError = true;
      this.errorMessage = 'Unable to load registration form';
      return;
    }

    if (this.destroyed || !this.isViewActive) {
      return;
    }

    // Load critical route data in a fresh call-stack frame.
    try {
      await this.loadCriticalData();
    } catch (error) {
      this.errorHandlerService.logError('Critical data load error', error);
    }
  }

  private determineUserLanguage(urlLang?: string): string {
    // Priority: URL > localStorage > browser > default (IP detection moved to background)
    if (urlLang && allLanguageCodes.includes(urlLang as Language)) {
      this.languageSource = 'url';
      return urlLang;
    }
    const storedLang = this.safeLocalStorage.getItem("language_code");
    if (storedLang && allLanguageCodes.includes(storedLang as Language)) {
      this.languageSource = 'storage';
      return storedLang;
    }
    const browserLang = navigator.language?.split("-")[0];
    if (browserLang && allLanguageCodes.includes(browserLang as Language)) {
      this.languageSource = 'browser';
      return browserLang;
    }
    // IP-based detection will happen in background via loadIPLocationData()
    this.languageSource = 'default';
    return defaultLanguage;
  }

  private determineUserCurrency(urlCurrency?: string): string {
    // Do not prefer stale localStorage — dropdown / URL / language / default are the source of truth.
    // Active-currency validation + write-back happen in selectChange / loadCurrencyData.
    if (urlCurrency) {
      this.currencySource = 'url';
      return urlCurrency;
    }
    const currencyByLanguage = {
      'fr': 'EUR', 'de': 'EUR', 'it': 'EUR', 'es': 'EUR', 'en': 'GBP'
    };
    if (currencyByLanguage[this.selectedLanguage]) {
      this.currencySource = 'language';
      return currencyByLanguage[this.selectedLanguage];
    }
    this.currencySource = 'default';
    return 'GBP';
  }


  private async initializeFormWithDefaults(): Promise<void> {
    const defaultCurrency = "GBP";
    // Add browser language detection
    const browserLang = navigator.language?.split("-")[0];
    const isBrowserLangSupported = allLanguageCodes.includes(browserLang as Language);
    const localStorageLanguage: Language = this.safeLocalStorage.getItem("language_code") as Language;
    const isStoredLanguageValid = localStorageLanguage && allLanguageCodes.includes(localStorageLanguage);
    // Get URL parameter language if present
    const urlLangParam = this.route.snapshot.queryParams?.lang?.toLowerCase();
    const isUrlLangValid = urlLangParam && allLanguageCodes.includes(urlLangParam as Language);
    const urlCurrencyParam = this.route.snapshot.queryParams?.currency?.toUpperCase();
    // Determine language using clear priority order
    this.selectedLanguage = isUrlLangValid
      ? (urlLangParam as Language)
      : isStoredLanguageValid
        ? localStorageLanguage
        : isBrowserLangSupported
          ? (browserLang as Language)
          : this.ipBasedUserLanguage
            ? this.ipBasedUserLanguage
            : defaultLanguage;
    // Initialize form using ONLY synchronous data (no blocking IP calls)
    // Language and currency are already determined in initializeCriticalData()

    // Apply lightweight synchronous setup first.
    this.translate.use(this.selectedLanguage);
    this.selectChange(this.selectedCurrency);

    // Yield to the event loop so the synchronous frames accumulated so far
    // (ngOnInit → initializeCriticalData → initializeFormWithDefaults) fully
    // unwind before running the deeper calls below. This is a second yield on
    // top of the one in initializeCriticalData and is specifically aimed at
    // preventing the WebKit call-stack overflow that surfaces as minified errors
    // like "Error: La" / "Error: fa" / "Error: Ca" / "Error: pa" on iPhone / Chrome Mobile iOS.
    await new Promise<void>(resolve => setTimeout(resolve, 0));

    // Component may have been destroyed or left during the yield (Ionic cache).
    if (this.destroyed || !this.isViewActive) {
      return;
    }

    // onLanguageChange, getSmartDefaultDialCode, and validateLoginForm can each
    // add significant call depth. Running them in this fresh stack frame keeps
    // the total depth well within WebKit's limit.
    // Apply the already-resolved selectedLanguage (URL > stored > browser > …),
    // not raw localStorage — otherwise a valid stored language would override
    // ?lang= after translate.use(this.selectedLanguage). Pass dropdown=true so
    // onLanguageChange uses the argument instead of re-reading localStorage.
    //
    // IMPORTANT: onLanguageChange synchronously calls selectedlanguage$.next(),
    // which fires all BehaviorSubject subscribers in the same call frame.
    // On WebKit (iPhone) the combined depth exceeds the shallower stack limit,
    // causing "RangeError: Maximum call stack size exceeded". We therefore
    // defer this call into a new event-loop task via another setTimeout(0) yield
    // so it always starts with a fully unwound call stack.
    if (isStoredLanguageValid) {
      await new Promise<void>(resolve => setTimeout(resolve, 0));
      if (this.destroyed || !this.isViewActive) {
        return;
      }
      this.onLanguageChange(this.selectedLanguage as Language, true);
    }

    if (this.destroyed || !this.isViewActive) {
      return;
    }

    // Notify language subscribers via a macrotask (setTimeout) to give WebKit a
    // genuinely fresh call-stack frame. queueMicrotask() is insufficient here:
    // microtasks run in the same event-loop turn and do NOT reset the stack depth
    // on WebKit/iPhone, so the BehaviorSubject subscriber chains can still overflow.
    // Fire-and-forget: subscriber exceptions must not abort this initialization path.
    // Cancel any previously scheduled timer before rescheduling (guards against
    // initializeFormWithDefaults being called more than once before the timer fires).
    if (this.langNotifyTimerId !== null) {
      clearTimeout(this.langNotifyTimerId);
    }
    // Only schedule if the view is still active (guards against ionViewWillLeave
    // running while an in-flight async init is still completing).
    if (!this.isViewActive) {
      return;
    }
    this.langNotifyTimerId = setTimeout(() => {
      this.langNotifyTimerId = null;
      if (this.destroyed || !this.isViewActive) {
        return;
      }
      try {
        this.authService.selectedlanguage$.next(this.selectedLanguage);
      } catch (err) {
        // Non-fatal: subscriber exceptions must not interrupt form initialization,
        // but we log them so real subscriber bugs remain diagnosable in production.
        try {
          this.errorHandlerService?.logError?.('selectedlanguage$.next error', err);
        } catch {
          // Logging must remain non-throwing.
        }
      }
    }, 0);

    // Prefer form-first URL/browser dial defaults; fall back to language/currency map.
    this.smartDefaultDialCode = this.initialDefaults?.dialCode || this.getSmartDefaultDialCode();
    this.ipstackCountryCode = this.smartDefaultDialCode;

    // Ensure form is initialized with smart dial code
    if (!this.createAccountForm) {
      this.validateLoginForm();
    } else {
      this.createAccountForm.get("dialCode").setValue(this.smartDefaultDialCode);
    }

    // Defer secondary service calls into a new macrotask (setTimeout) so the current
    // synchronous stack fully unwinds first. Using setTimeout instead of
    // queueMicrotask gives WebKit a genuinely fresh call-stack frame — microtasks
    // run in the same event-loop turn and do not reset stack depth on WebKit (iPhone).
    // Fire-and-forget: callers of initializeFormWithDefaults() do not need to wait
    // for this secondary/analytics/IP block; preserves original fire-and-forget semantics.
    // Cancel any previously scheduled timer before rescheduling (guards against
    // initializeFormWithDefaults being called more than once before the timer fires).
    if (this.secondaryInitTimerId !== null) {
      clearTimeout(this.secondaryInitTimerId);
    }
    // Only schedule if the view is still active.
    if (!this.isViewActive) {
      return;
    }
    this.secondaryInitTimerId = setTimeout(() => {
      this.secondaryInitTimerId = null;
      if (this.destroyed || !this.isViewActive) {
        return;
      }
      try {
        this.languageArray = this.partialRegistrationHelperService.getSelectedLanguage(
          this.languageArray,
          this.selectedLanguage
        );
        this.currencyArray = this.partialRegistrationHelperService.getSelectedCurrency(
          this.currencyArray,
          this.selectedCurrency
        );
        this.safeLocalStorage.setItem("language_code", this.selectedLanguage);
        this.safeLocalStorage.setItem("user_currency", this.selectedCurrency);
        // Log language selection for analytics
        this.logLanguageSelection();

        // Trigger IP-based detection in background (non-blocking)
        this.loadUserDetailsBasedOnIPInBackground();
      } catch (err) {
        try {
          this.errorHandlerService?.logError?.('Form secondary initialization error', err);
        } catch {
          // Logging must remain non-throwing
        }
      }
    }, 0);
  }


  // Non-blocking version - fires in background without blocking form rendering
  private loadUserDetailsBasedOnIPInBackground(): void {
    // Fire and forget - this won't block the critical rendering path
    this.getUserDetailsBasedOnIP().catch(err => {
      this.errorHandlerService.logError('Background IP detection failed', err);
    });
  }


  private logLanguageSelection(): void {
    this.GTMService?.trackEvent('registration_language_source', {
      source: this.languageSource,
      language: this.selectedLanguage,
      currency_source: this.currencySource,
      currency: this.selectedCurrency
    });
  }

  private handleOfflineRegistration(queueId: string): void {
    this.spinnerAnimation = false;

    this.errorHandlerService.showTranslatedMessage(null, {
      message: {
        line_1: "Your registration has been saved. We'll complete it when you're back online.",
        line_2: ""
      },
      style: {
        icon: "cloud-done",
        type: "Success"
      }
    });

    // Navigate to a pending registration page
    this.router.navigate(['/registration-pending'], {
      queryParams: {
        queueId: queueId,
        offline: true
      }
    });
  }

  private showSlowConnectionWarning(): void {
    this.errorHandlerService.showTranslatedMessage(null, {
      message: {
        line_1: "Your connection is slow. Registration may take a little longer."
      },
      style: {
        icon: "hourglass_empty",
        type: "Info"
      }
    });
  }

  // Monitor connection changes
  private setupConnectionMonitoring(): void {
    this.connectionManagerService.connectionStateChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.isOnline && this.connectionManagerService.getQueuedCount() > 0) {
          this.showQueuedRegistrationNotification();
        }
      });
  }

  private showQueuedRegistrationNotification(): void {
    const count = this.connectionManagerService.getQueuedCount();
    this.errorHandlerService.showTranslatedMessage(null, {
      message: {
        line_1: count === 1
          ? "Back online. Processing 1 pending registration."
          : `Back online. Processing ${count} pending registrations.`,
        line_2: ""
      },
      style: {
        icon: "sync",
        type: "Info"
      }
    });
  }


  setValuesGlobally() {
    this.tp1 = this.partialRegistrationHelperService.setValues(this.tp1, "TP1");
    this.upsell_ID = this.partialRegistrationHelperService.setValues(this.upsell_ID, "upsell_ID");
    this.tp2 = this.partialRegistrationHelperService.setValues(this.tp2, "TP2");
    this.tp3 = this.partialRegistrationHelperService.setValues(this.tp3, "TP3");
    this.t_id = this.partialRegistrationHelperService.setValues(this.t_id, "T_ID");
    this.other = this.partialRegistrationHelperService.setValues(this.other, "Other");
    this.prosub_id = this.partialRegistrationHelperService.setValues(this.prosub_id, "prosub_id");
  }

  updateDialCode() {
    this.languageArray?.map((item) => {
      if (item?.selected) {
        const selectedCountryCode = this.ipstackCountryCode ?? CommonVariable.defaultDialCode;
        this.createAccountForm?.get("dialCode")?.setValue(selectedCountryCode);
      }
    });
  }

  transTooltip() {
    this.translate
      .get(["create-account.toolTipText"])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: Data) => {
          this.toolTipText = res["create-account.toolTipText"];
        },
        error: (err) => {
          this.errorHandlerService.logError('Translation fetch error:', err);
        }
      });
  }


  getUserDetailsBasedOnIP(): Promise<void> {
    return new Promise((resolve) => {
      this.userManagementService
        .getUserCountryBaseOnIP()
        .pipe(
          takeUntil(this.destroy$),
          catchError(err => {
            this.errorHandlerService.logError('getUserCountryBaseOnIP failed', err);
            // Return default GB data as fallback
            return of({ country_code: "GB", location: { calling_code: "44" } });
          }),
          switchMap((res: Data) => {
            const countryCode = res?.country_code ?? "GB";
            this.ipstackCountryCode =
              "+" + (res?.location?.calling_code || CommonVariable.defaultDialCode);
            if (!this.hasUserInteraction() && !this.initialDefaults?.hasUrlDial) {
              this.createAccountForm?.get("dialCode")?.setValue(this.ipstackCountryCode);
            }
            return this.authService.getCurrencyAndLanguageList$.pipe(
              takeUntil(this.destroy$),
              catchError(err => {
                this.errorHandlerService.logError('getCurrencyAndLanguageList$ failed', err);
                // Return default GB data
                return of({ GB: { language: "en", currency: "GBP" } });
              }),
              map((data: Data) => {
                const countriesArray = Object.keys(data);
                if (countryCode && countriesArray.includes(countryCode)) {
                  return data[countryCode] ?? data["GB"];
                } else {
                  return data["GB"];
                }
              })
            );
          })
        )
        .subscribe({
          next: (data: Data) => {
            this.ipBasedUserLanguage = data?.language ?? "";
            this.ipBasedUserCurrency = data?.currency ?? "";

            const localStorageCurrency = this.safeLocalStorage.getItem("user_currency");
            if (!localStorageCurrency) {
              this.selectChange(this.selectedCurrency);
            }

            this.selectedLanguage = this.ipBasedUserLanguage;

            const localStorageLanguage: Language = this.safeLocalStorage.getItem("language_code") as Language;
            if (!localStorageLanguage) {
              this.onLanguageChange(this.selectedLanguage as Language);
            }

            resolve();
          },
          error: (err) => {
            this.errorHandlerService.logError('getUserDetailsBasedOnIP subscription error', err);
            // Still resolve to not block initialization
            resolve();
          }
        });
    });
    // This method is now DEPRECATED and only kept for compatibility
    // All IP-based detection happens in loadIPLocationData() during background loading
    // Return immediately to prevent blocking
  }

  // Proper validator updates that include clearing and updating
  checkForModules(modData) {
    if (!modData) {
      this.errorHandlerService.logError('Module data is missing or invalid');
      return;
    }
    // Define the validation changes to apply
    const validationChanges = {
      email: {
        show: !!modData.email,
        validators: [Validators.required, Validators.pattern(this.EMAIL_PATTERN)],
      },
      voucher_code: {
        show: !!modData.voucher,
        validators: modData.voucher ? [Validators.required] : [],
      },
      terms_condition: {
        show: !!modData.terms_condition,
        validators: modData.terms_condition ? [Validators.requiredTrue] : [],
      },
      msn: {
        show: !!modData.msn,
      },
      date_of_birth: {
        show: !!modData.dob,
        validators: modData.dob
          ? [Validators.required, this.dateOfBirthValidation.bind(this)]
          : [],
      },
    };
    // Update component state
    this.showEmail = validationChanges.email.show;
    this.showVoucher = validationChanges.voucher_code.show;
    this.showTerms = validationChanges.terms_condition.show;
    this.showMSN = validationChanges.msn.show;
    this.showDob = validationChanges.date_of_birth.show;

    // Apply validation changes
    if (this.createAccountForm) {
      try {
        // Update email validators
        const emailControl = this.createAccountForm.get("email");
        if (emailControl) {
          emailControl.clearValidators();
          if (this.showEmail) {
            emailControl.setValidators(validationChanges?.email?.validators);
          }
          emailControl.updateValueAndValidity();
        }

        // Update voucher code validators
        const voucherControl = this.createAccountForm.get("voucher_code");
        if (voucherControl) {
          voucherControl.clearValidators();
          if (this.showVoucher) {
            voucherControl.setValidators(validationChanges.voucher_code.validators);
          }
          voucherControl.updateValueAndValidity();
        }

        // Update terms validators
        const termsControl = this.createAccountForm.get("agreeToTerms");
        if (termsControl) {
          termsControl.clearValidators();
          if (this.showTerms) {
            termsControl.setValidators(validationChanges.terms_condition.validators);
          }
          termsControl.updateValueAndValidity();
        }

        const dobControl = this.createAccountForm.get("date_of_birth");
        if (dobControl) {
          dobControl.clearValidators();
          if (this.showDob) {
            dobControl.setValidators(validationChanges.date_of_birth.validators);
          }
          dobControl.updateValueAndValidity();
        }

        // If MSN is hidden, hide phone number and dial code fields
        if (!this.showMSN) {
          const phoneControl = this.createAccountForm.get("phoneNumber");
          const dialCodeControl = this.createAccountForm.get("dialCode");

          if (phoneControl) {
            phoneControl.clearValidators();
            phoneControl.updateValueAndValidity();
          }

          if (dialCodeControl) {
            dialCodeControl.clearValidators();
            dialCodeControl.updateValueAndValidity();
          }
        }
      } catch (error) {
        this.errorHandlerService.logError('Error updating form validators:', error);
      }
    }
    this.loaded = true;
  }

  toggleDisplayDiv() {
    this.isShowDiv = !this.isShowDiv;
  }
  // Better email regex pattern
  private validateLoginForm() {
    this.createAccountForm = this.fb.group({
      phoneNumber: [
        "",
        [Validators.required, Validators.minLength(4), Validators.maxLength(10), Validators.pattern("^[0-9]+$")],
      ],
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          // Consider adding more password strength validation here
        ],
      ],
      date_of_birth: [""],
      email: ["", this.showEmail ? [Validators.required, Validators.pattern(this.EMAIL_PATTERN)] : []],
      voucher_code: ["", this.showVoucher ? [] : []],
      agreeToTerms: [true, this.showTerms ? Validators.requiredTrue : []],
      preferenceTick: [false],
      dialCode: [this.smartDefaultDialCode, [Validators.required]], // Default to UK dial code
    });

    this.createAccountForm
      .get('dialCode')
      .valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value && value !== this.smartDefaultDialCode) {
          this.userModifiedDialCode = true;
        }
      })
  }

  private getSmartDefaultDialCode(): string {
    const langCurrencyKey = `${this.selectedLanguage}_${this.selectedCurrency}`;
    if (this.LANGUAGE_CURRENCY_TO_DIAL_CODE[langCurrencyKey]) {
      return this.LANGUAGE_CURRENCY_TO_DIAL_CODE[langCurrencyKey];
    }

    if (this.LANGUAGE_CURRENCY_TO_DIAL_CODE[this.selectedLanguage]) {
      return this.LANGUAGE_CURRENCY_TO_DIAL_CODE[this.selectedLanguage];
    }

    if (this.LANGUAGE_CURRENCY_TO_DIAL_CODE[this.selectedCurrency]) {
      return this.LANGUAGE_CURRENCY_TO_DIAL_CODE[this.selectedCurrency];
    }

    return '+44';
  }

  toggleViewPassword(): void {
    this.passwordType = this.passwordType === "text" ? "password" : "text";
    this.passwordIcon = this.passwordIcon === "eye" ? "eye-off" : "eye";
  }

  dateOfBirthValidation(control: FormControl) {
    if (control?.value) {
      const now = new Date();
      const dob = new Date(control.value);
      if (Number.isNaN(dob.getTime())) {
        return { futureInvalidDate: true };
      }
      const eighteenYearsAgo = new Date();
      eighteenYearsAgo.setFullYear(now.getFullYear() - 18);
      if (dob >= eighteenYearsAgo) {
        return { futureInvalidDate: true };
      }
    }
    return null;
  }

  openDateModal(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.isDateModalOpen) return;

    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    this.maxDateOfBirth = eighteenYearsAgo.toISOString();
    this.defaultDateOfBirth ||= this.maxDateOfBirth;
    this.isDateModalOpen = true;

    const control = this.createAccountForm.get("date_of_birth");
    control?.markAsTouched();
    control?.updateValueAndValidity();
  }

  onDateChange(event): void {
    const value = event?.detail?.value;
    if (!value) return;

    const control = this.createAccountForm.get("date_of_birth");
    control?.patchValue(moment(value).format("MM/DD/yyyy"));
    control?.markAsTouched();
    control?.updateValueAndValidity();
    this.dobDate = value;
    this.defaultDateOfBirth = value;
    // Persist for Free Reg Complete Profile autofill (same key as age-verification)
    localStorage.setItem("defaultDob", value);
  }

  closeDateModal(): void {
    this.isDateModalOpen = false;
  }

  getNumericOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }

  // Updated phone number validation method
  getPhoneNumber(event) {
    let inputPhoneNumber = event?.target?.value || "";

    // Enforce maximum length (based on remaining digits after dial code)
    const maxPhoneDigits = 15; // International standard for max phone digits
    const dialCode = this.createAccountForm.get("dialCode").value || "";
    const maxInputLength = maxPhoneDigits - dialCode.replace(/^\+/, "").length;

    if (inputPhoneNumber.length > maxInputLength) {
      inputPhoneNumber = inputPhoneNumber.slice(0, maxInputLength);
    }

    // Validate phone number format - only allow digits
    const phoneNumberRegex = /^\d+$/;
    const isPhoneNumberValid = phoneNumberRegex.test(inputPhoneNumber);

    // Set value to form control (raw number without dial code)
    this.createAccountForm.get("phoneNumber").setValue(inputPhoneNumber);

    // Set or clear errors
    if (!isPhoneNumberValid || inputPhoneNumber.length < 4) {
      this.createAccountForm.get("phoneNumber").setErrors({ incorrectPhoneNumber: true });
      this.phoneInValid = true;
    } else {
      this.createAccountForm.get("phoneNumber").setErrors(null);
      this.phoneInValid = false;
    }

    // Store for reference
    this.newPhoneNumber = inputPhoneNumber;
  }
  phoneNumberHasError(hasError: boolean) {
    this.incorrectPhoneNumber = hasError;
    this.createAccountForm.get("phoneNumber").setErrors({
      incorrectPhoneNumber: !hasError,
    });
    if (this.phoneNumberInput) this.phoneInValid = this.phoneNumberInput.nativeElement.value ? true : false;
  }

  /** Re-entrancy guard: prevents recursive calls via synchronous BehaviorSubject emissions. */
  private isLanguageChanging = false;

  onLanguageChange(language: Language, dropdown?: boolean) {
    if (dropdown) this.userSelectedLanguage = true;
    // Guard against re-entrant calls triggered by the synchronous BehaviorSubject
    // emissions below. On WebKit (iPhone) the subscriber chains can be deep enough
    // to overflow the shallower call stack without this guard.
    if (this.isLanguageChanging) {
      return;
    }
    this.isLanguageChanging = true;
    try {
      language = allLanguageCodes.includes(language) ? language : defaultLanguage;

      const storedLanguageCode = this.safeLocalStorage.getItem("language_code");
      let currentSelectedLanguage = storedLanguageCode;
      // Check if language code needs to be updated in localStorage
      /*   if (this.languageParamState || storedLanguageCode === "" || storedLanguageCode === null || language !== "en") {
        // Update language_code in localStorage
        currentSelectedLanguage = language;
      } */
      if (dropdown) currentSelectedLanguage = language;
      const prevLocalLang = this.safeLocalStorage.getItem("language_code") || "";
      this.userManagementService.setUserLanguageLogInFb(
        prevLocalLang,
        currentSelectedLanguage,
        "partial-reg onLanguageChange"
      );

      // Synchronous state updates that must happen immediately for correct UI rendering.
      this.safeLocalStorage.setItem("language_code", currentSelectedLanguage);
      this.translate.use(currentSelectedLanguage);
      this.transTooltip();

      // Defer BehaviorSubject .next() emissions into a fresh event-loop task via
      // setTimeout(0).  All three calls are synchronous and their subscriber chains
      // can be arbitrarily deep; on WebKit/iPhone the combined call-stack depth
      // (Angular init → navigation → onLanguageChange → subscriber chains) exceeds
      // the shallower stack limit, causing "RangeError: Maximum call stack size
      // exceeded".  A genuinely fresh macrotask (setTimeout, not queueMicrotask)
      // resets the stack depth before any subscriber fires.
      // Cancel any previously pending deferred notification (handles rapid calls).
      if (this.langChangeNotifyTimerId !== null) {
        clearTimeout(this.langChangeNotifyTimerId);
      }
      const langSnapshot = currentSelectedLanguage;
      this.langChangeNotifyTimerId = setTimeout(() => {
        this.langChangeNotifyTimerId = null;
        if (this.destroyed || !this.isViewActive) {
          return;
        }
        try {
          this.AuthPartialRegService.selectedlanguage$.next(langSnapshot);
          this.authService.selectedlanguage$.next(langSnapshot);
          this.authService.isLanguageChangeTrigger$.next(true);
        } catch (err) {
          try {
            this.errorHandlerService?.logError?.('onLanguageChange deferred .next() error', err);
          } catch {
            // Logging must remain non-throwing.
          }
        }
      }, 0);
    } finally {
      this.isLanguageChanging = false;
    }
  }

  selectChange(currency: string, dropdown?: boolean) {
    // Always use the incoming/dropdown currency as the single source of truth.
    // Do not preserve a stale localStorage value when the UI shows GBP.
    let currentSelectedCurrency = currency || "GBP";
    const activeCodes = (this.currencyArray || [])
      .map((c) => c?.currency_code)
      .filter(Boolean);
    if (activeCodes.length > 0 && !activeCodes.includes(currentSelectedCurrency)) {
      currentSelectedCurrency = "GBP";
    }
    if (dropdown) {
      this.userSelectedCurrency = true;
    }
    this.selectedCurrency = currentSelectedCurrency;
    this.userManagementService.selectedCurrency = currentSelectedCurrency;
    this.safeLocalStorage.setItem("user_currency", currentSelectedCurrency);
  }

  onLanguageSelect(flag: FlagInterface) {
    this.selectedFlag = flag;
    this.onLanguageChange(flag.country_code);
  }
  // Create a centralized phone number formatter
  private formatPhoneNumber(phoneNumber: string, dialCode: string): string {
    // Remove leading zero if present
    if (phoneNumber.startsWith("0")) {
      phoneNumber = phoneNumber.substring(1);
    }

    // Remove dial code from the beginning if it's already there
    // This prevents duplicate dial codes
    const dialCodeWithoutPlus = dialCode.replace(/^\+/, "");
    const dialCodeRegex = new RegExp(`^(\\+?${dialCodeWithoutPlus})`);
    phoneNumber = phoneNumber.replace(dialCodeRegex, "");

    // Add the dial code to the formatted phone number
    return dialCode + phoneNumber;
  }

  async onCreateAccountFormSubmit() {
    try {
      if (this.offerState !== 'ready' || !this.prosub_id || !this.prosubOfferId || !this.hasOfferCurrency()) {
        this.resetSpinnerState?.();
        this.errorHandlerService?.showTranslatedMessage?.(null, {
          message: { line_1: this.offerError || 'Offer details are still loading. Please wait or retry.' },
          style: { icon: 'tick circle error.svg', type: 'Error' },
        });
        return;
      }
      this.startSpinner();
      const turnstileToken = await this.executeTurnstileChallenge();
      if (this.turnstileEnabled && !turnstileToken) {
        this.resetSpinnerState();
        this.errorHandlerService.showTranslatedMessage(null, {
          message: {
            line_1: "We couldn't complete the security check. Try again."
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error"
          },
        });

        // Reset Turnstile for retry
        if ((window as any).turnstile && this.turnstileWidgetId !== null) {
          (window as any).turnstile.reset(this.turnstileWidgetId);
        }
        return;
      }
      const user = this.createAccountForm?.value as Data ?? {};
      if (!this.showDob) {
        delete user.date_of_birth;
      } else if (this.dobDate || user.date_of_birth) {
        // Ensure DOB carries to Free Reg Complete Profile even if picker change was missed
        localStorage.setItem("defaultDob", this.dobDate || user.date_of_birth);
      }
      // Add Turnstile token to user data
      if (turnstileToken && turnstileToken !== 'bypass') {
        user.turnstileToken = turnstileToken;
      }

      const dialCode = user?.dialCode || '';
      const phoneNumber = user?.phoneNumber || '';

      // Check connection state safely
      const connectionState = this.connectionManagerService?.getConnectionState?.();
      if (!connectionState?.isOnline) {
        const queueId = await this.connectionManagerService.queueRegistration(user);
        this.handleOfflineRegistration(queueId);
        return;
      }

      if (!connectionState?.isFirestoreConnected) {
        this.showSlowConnectionWarning?.();
      }

      // ✅ Normalize phone number safely
      user.phoneNumber = this.normalizePhoneNumber?.(phoneNumber, dialCode) ?? phoneNumber;
      const userMSN = user?.phoneNumber?.replace(/^\+/, '') || '';
      this.authService?.userMSN$?.next(userMSN);

      this.vc = this.createAccountForm?.get("voucher_code")?.value || this.vc;

      // ✅ Twilio validation with full fallback
      const twilioData = await firstValueFrom(
        this.twillioValidation().pipe(
          takeUntil(this.destroy$),
          timeout(15000),
          catchError(error => {
            this.errorHandlerService?.logError?.('Twilio validation failed:', error);
            return of({
              success: false,
              message: error?.message || "Twilio validation timeout or error.",
            });
          })
        )
      );

      if (twilioData?.success) {
        // Populate fallback-safe registration fields
        user.prosub_id = this.prosub_id || this.default_prosub_id || '';
        user.language_code = this.authService?.selectedlanguage$?.value ?? defaultLanguage;
        user.preferred_currency = this.userManagementService?.selectedCurrency || 'GBP';
        user.tp1 = this.tp1 ?? '';
        user.tp2 = this.tp2 ?? '';
        user.tp3 = this.tp3 ?? '';
        user.t_id = this.t_id ?? '';
        user.other = this.other ?? '';
        user.country_code = dialCode.replace(/^\+/, '') || '';
        this.safeLocalStorage.setItem("msn", userMSN);
        this.safeLocalStorage.setItem("country_code", user.country_code);

        // Overlap 4C partialregv2 warm with the remaining registration critical path
        // (validatesalesignup / anonymous login / SQL / Firebase).
        this.AuthPartialRegService.startJourneyPartialRegPrefetch(user.prosub_id);

        this.registerUserForSalesJourney?.(user);

        // Save preferences with fallback guards
        this.safeLocalStorage?.setItem?.("preferenceTick", user.preferenceTick ?? 'false');
        this.safeLocalStorage?.setItem?.("proSub", "proSub");
      } else {
        const messageCode = twilioData?.reason === "blocked_phone_code" ? "" : "1078";

        this.resetSpinnerState?.();
        this.errorHandlerService?.showTranslatedMessage?.(messageCode, {
          message: {
            line_1: twilioData?.message || "Enter a valid mobile number",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        });
      }
    } catch (err: any) {
      this.resetSpinnerState?.();
      const errorMsg = err?.message || "We couldn't create your account. Try again.";
      this.errorHandlerService?.showTranslatedMessage?.(null, {
        message: { line_1: errorMsg },
        style: { icon: "tick circle error.svg", type: "Error" },
      });

      this.errorHandlerService?.logError?.('Registration form error', err);
    }
  }




  private normalizePhoneNumber(phoneNumber: string, dialCode: string): string {
    if (!phoneNumber || !dialCode) return phoneNumber;

    let normalizedPhone = phoneNumber.replace(/^\+/, '');
    const dialCodeWithoutPlus = dialCode.replace(/^\+/, '');

    if (normalizedPhone.startsWith(dialCodeWithoutPlus)) {
      normalizedPhone = normalizedPhone.substring(dialCodeWithoutPlus.length);
    }

    if (normalizedPhone.startsWith('0')) {
      normalizedPhone = normalizedPhone.substring(1);
    }

    return `+${dialCodeWithoutPlus}${normalizedPhone}`;
  }

  registerUserForSalesJourney(user: any) {
    if (this.blocklogin) {
      let currDate = moment();
      let dateToTest = moment(this.blocklogin.toISOString());
      let result = currDate.diff(dateToTest, "minutes");
      if (result < 15) {
        this.spinnerAnimation = false;
        /* let msg = "Please try again after " + (15 - result) + " minutes";
        this.authService.showToast(msg ? msg : "Code Error", "Error", ""); */
        const num = 15;
        const minutesLeft = num - result;
        const rateLimitMessage = `Too many attempts. Try again in ${minutesLeft} minutes.`;
        const translatedMsg = {
          message: {
            line_1: rateLimitMessage,
            line_2: "",
          },
          style: {
            duration: 2000,
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        const defaultMsg = {
          message: {
            line_1: rateLimitMessage,
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
        return;
      }
    }
    if (window.navigator.onLine) {
      const userMSN = user?.phoneNumber?.replace(/^\+/, "");
      let currency = this.userManagementService.selectedCurrency;
      const cp_request = {
        user_id: user?.user_id ?? userMSN,
        prosub_id: this.prosub_id,
        TP1: this.tp1,
        TP2: this.tp2,
        TP3: this.tp3,
        T_ID: this.t_id,
        offer_id: user.offer_id ?? this.prosubOfferId ?? "",
        value: user.value ?? this.prosubPrice ?? "",
        preferred_currency: {
          Value: String(
            this.prosubIntPrice?.[currency]
              ? this.prosubIntPrice?.[currency]?.toFixed(2)
              : this.prosubPrice
                ? this.prosubPrice?.toFixed(2)
                : 0
          ),
          currency: currency ?? "",
        },
        p_type: user.p_type ?? "10",
        product_description: user?.product_description ?? "",
        other: this.other ?? "",
      };
      this.partialRegistrationHelperService.setPreferredCurrency(this.prosubIntPrice, this.prosubPrice);

      this.authService
        .validateAndRegisterUser(user, cp_request)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: ({ type, validateSignupRes }) => {
            this.proceed = true;
            if (type === "existing_user") {
              this.existingUserFlow(validateSignupRes);
              return;
            } else if (type === "wrong_password") {
              this.wrongPasswordFlow();
              return;
            } else {
              this.newRegistrationFlow(validateSignupRes);
            }
          },
          error: (err) => {
            // Failure tracking for registration attempt
            this.GTMService.collectVisitorData("", "", 1, 0);
            this.handleError(err, {
              resetSpinner: true,
              showToast: true,
              customAction: () => {
                if (err?.message?.includes("This user is already registered, please login with correct password.")) {
                  this.wrongLoginAttempt++;
                  if (this.wrongLoginAttempt >= 1) {
                    this.openForgetPassword();
                  }
                  this.wrongCredentialMatched = true;
                }
              },
            });
          },
        });
    }
  }

  /**
   * The existingUserFlow function handles the flow for existing users during signup, including
   * displaying a success message, updating user profile, and navigating to a specific page.
   */

  /**
   * Existing MSN users already have an account — skip the Account Created celebration
   * page and continue straight into the sales/4C destination for this offer.
   */
  private resolveExistingUserNextPage(): string {
    const candidates = [
      this.GTMService?.prosubDetails?.optional_page,
      this.GTMServise?.prosubDetails?.optional_page,
    ];
    for (const raw of candidates) {
      if (!raw) continue;
      const page = String(raw).split("?")[0].trim();
      if (!page) continue;
      const normalized = page.replace(/^\/+/, "");
      if (!normalized || normalized === "account-created") continue;
      if (normalized.includes("partial-registration")) continue;
      return normalized.startsWith("/") ? normalized : `/${normalized}`;
    }
    return "/free-reg-step4c";
  }

  existingUserFlow(validateSignupRes: Data): void {
    let phoneNumber = this.createAccountForm.get("phoneNumber").value;
    if (phoneNumber.startsWith("0")) phoneNumber = phoneNumber.substring(1);
    phoneNumber = this.createAccountForm.get("dialCode").value + phoneNumber;
    this.GTMServise.Clevertap_profile_push(phoneNumber);
    this.clarityService.event("login_success");
    // Success tracking (existing user login via partial registration)
    this.GTMService.collectVisitorData("", "", 1, 1);
    this.errorHandlerService.showTranslatedMessage("1077", {
      message: {
        line_1: "You already have an account. We're logging you in.",
      },
      style: {
        icon: "tick circle success.png",
        type: "Success",
      },
    });
    this.matDialog.closeAll();
    // this.GTMServise.userIsNew = true;
    this.vc = this.vc;
    if (validateSignupRes) {
      this.GTMServise.GTM_account_created(phoneNumber);
      this.progressBar = 100;
      this.spinnerAnimation = false;
      const nextPage = this.resolveExistingUserNextPage();
      this.uploadUserFingerprintInfo();
      this.router.navigate([nextPage], {
        queryParams: {
          prosub_id: this.prosub_id,
          ...this.GTMServise.queryParamsToNavigate,
          vc: this.vc,
          TP1: this.tp1 ? this.tp1 : "null",
          TP2: this.tp2 ? this.tp2 : "null",
          TP3: this.tp3 ? this.tp3 : "null",
          T_ID: this.t_id ? this.t_id : "",
          Other: this.other ? this.other : "",
          upsell_ID: this.upsell_ID ? this.upsell_ID : "",
          call_from: this.callFromPromotion,
          gc: this.gc || "",
          pt: this.pt || "",
        },
      });
    }
  }

  /**
   * The wrongPasswordFlow function closes all dialogs, opens the forget password dialog, sets progress
   * bar to 100, disables spinner animation, sets proceed to true, and displays a success message for
   * already registered users.
   */
  wrongPasswordFlow(): void {
    this.matDialog.closeAll();
    this.openForgetPassword();
    this.progressBar = 100;
    this.spinnerAnimation = false;
    this.proceed = true;
    // Failure tracking (wrong password path)
    this.GTMService.collectVisitorData("", "", 1, 0);
    const alreadyRegisteredCopy = {
      en: "An account already exists for this mobile number. Log in or reset your password.",
      it: "Esiste già un account per questo numero di cellulare. Accedi o reimposta la password.",
      fr: "Un compte existe déjà pour ce numéro de portable. Connectez-vous ou réinitialisez votre mot de passe.",
      es: "Ya existe una cuenta con este número de móvil. Inicia sesión o restablece tu contraseña.",
      pt: "Já existe uma conta associada a este número de telemóvel. Inicie sessão ou reponha a sua palavra-passe.",
    };
    const lang = (this.authService?.selectedlanguage$?.value || this.selectedLanguage || "en") as keyof typeof alreadyRegisteredCopy;
    this.toastFacadeService.showInline(
      {
        message: {
          line_1: alreadyRegisteredCopy[lang] || alreadyRegisteredCopy.en,
          line_2: "",
        },
        style: {
          icon: "tick circle error.svg",
          type: "error",
          duration_ms: 5000,
        },
        context: {
          journey: "partial_registration",
          trigger: "wrong_password_flow",
          reason_code: "wrong-password",
        },
      }
    );
  }

  /**
   * The function `newRegistrationFlow` handles the registration flow by processing user input, updating
   * user data, and navigating to a new page upon successful validation.
   */
  newRegistrationFlow(validateSignupRes: Data): void {
    let phoneNumber = this.createAccountForm.get("phoneNumber").value;
    if (phoneNumber.startsWith("0")) phoneNumber = phoneNumber.substring(1);
    phoneNumber = this.createAccountForm.get("dialCode").value + phoneNumber;
    this.GTMServise.Clevertap_profile_push(phoneNumber);
    this.matDialog.closeAll();
    this.GTMServise.userIsNew = true;
    this.vc = this.vc;
    if (validateSignupRes) {
      this.GTMServise.GTM_account_created(phoneNumber);
      // Phase 1: unblock when SQL signup succeeds or auth token is ready — not full DFCI/Firestore profile.
      // createFbUser can continue promoting auth to DFCI in the background after navigate.
      // Bound matches validateAndRegisterUser outer timeout (45s). Keep spinner/progress as interim
      // pending UX; only show retry after this final bound (or a confirmed failure elsewhere).
      const PHASE1_READY_MAX_MS = 45000;
      const phase1StartedAt = Date.now();
      const phase1CorrelationId = `reg-phase1-${phase1StartedAt}-${Math.random().toString(36).slice(2, 10)}`;
      const phase1ProsubId = String(this.prosub_id ?? this.default_prosub_id ?? "");
      this.spinnerAnimation = true;
      this.authService.errorHandlerLogs("[registration] stage timing", {
        stage: "phase1Ready_wait",
        correlationId: phase1CorrelationId,
        prosub_id: phase1ProsubId,
        waitMs: PHASE1_READY_MAX_MS,
      });
      const phase1Ready$ = merge(
        this.authService.callSigUpForSalesResponse$.pipe(
          filter((res) => res?.response?.status === "SUCCESS" && !!res?.response?.customer_id)
        ),
        this.authService.authReady$.pipe(filter((ready) => !!ready))
      ).pipe(
        take(1),
        timeout({
          first: PHASE1_READY_MAX_MS,
          with: () => {
            this.authService.errorHandlerLogs("[registration] stage timing", {
              stage: "phase1Ready_timeout",
              timeoutStage: "phase1Ready",
              correlationId: phase1CorrelationId,
              prosub_id: phase1ProsubId,
              elapsedMs: Date.now() - phase1StartedAt,
              waitMs: PHASE1_READY_MAX_MS,
              authReady: !!this.authService.authReady$.value,
            });
            return throwError(
              () =>
                new Error(
                  "Registration is taking longer than expected. Please try again."
                )
            );
          },
        }),
        takeUntil(this.destroy$)
      );

      phase1Ready$.subscribe({
        next: () => {
          this.authService.errorHandlerLogs("[registration] stage timing", {
            stage: "phase1Ready_complete",
            correlationId: phase1CorrelationId,
            prosub_id: phase1ProsubId,
            elapsedMs: Date.now() - phase1StartedAt,
            authReady: !!this.authService.authReady$.value,
          });
          this.progressBar = 100;
          this.spinnerAnimation = false;
          this.GTMService.collectVisitorData("", "", 1, 1);
          this.clarityService.event("sign_up_complete");
          // HATDEV-100772: /partial-registration — pass stored user_id; getUid retry if missing
          this.posthogService.emitRegistrationCompleted(
            "partial_registration_sign_up_complete",
            this.partialRegistrationHelperService.getUserId()
          );
          this.uploadUserFingerprintInfo();
          this.router.navigate(["/account-created"], {
            queryParams: {
              prosub_id: this.prosub_id,
              ...this.GTMServise.queryParamsToNavigate,
              vc: this.vc,
              TP1: this.tp1 ? this.tp1 : "null",
              TP2: this.tp2 ? this.tp2 : "null",
              TP3: this.tp3 ? this.tp3 : "null",
              T_ID: this.t_id ? this.t_id : "",
              Other: this.other ? this.other : "",
              call_from: this.callFromPromotion,
              gc: this.gc || "",
              pt: this.pt || "",
            },
          });
        },
        error: (error) => {
          this.GTMService.collectVisitorData("", "", 1, 0);
          this.handleError(error, { resetSpinner: true, showToast: true });
        },
      });
    }
  }

  private twillioValidation() {
    const phoneNumberControl = this.createAccountForm.get("phoneNumber");
    const dialCodeControl = this.createAccountForm.get("dialCode");

    if (!phoneNumberControl?.value) {
      return of({ success: false, message: "Enter your mobile number" });
    }

    let phoneNumber = phoneNumberControl.value;
    const dialCode = dialCodeControl?.value || "";

    // Block malicious phone codes used by bots
    const BLOCKED_PHONE_CODES = ['+359', '+380', '+261', '+601', '+524', '+60', '+52'];

    if (BLOCKED_PHONE_CODES.includes(dialCode)) {
      console.warn('Registration blocked:', {
        reason: 'blocked_phone_code',
        code: dialCode,
        timestamp: new Date().toISOString()
      });

      return of({
        success: false,
        reason: 'blocked_phone_code',
        message: "Registration isn't available in your region. Contact support if you think this is a mistake."
      });
    }

    // Remove leading zero without mutating form
    if (phoneNumber.startsWith("0")) {
      phoneNumber = phoneNumber.substring(1);
    }

    // Add dial code if not present
    if (!phoneNumber.startsWith(dialCode)) {
      phoneNumber = dialCode + phoneNumber;
    }

    // Pass the formatted number to validation without mutating form
    return this.authService.validateTwilio(phoneNumber);
  }

  showPolicy(contentType: string) {
    if (contentType === "preference") {
      this.bottomSheet.open(PreferenceComponent, {
        panelClass: "privacy-terms-dialog",
      });
    } else {
      /* To show the terms and policy Pop up */
      const privacyPolicy = this.bottomSheet.open(TermsAndPolicyComponent, {
        panelClass: "terms-dialog",
        data: { contentType: contentType, signup: true },
      });
    }
  }

  startSpinner(): void {
    try {
      // Ensure any previous spinner state is reset
      this.spinnerAnimation = true;
      this.progressBar = 0;

      // Guard: Clear any existing subscription
      if (this.sub) {
        this.sub.unsubscribe();
        this.sub = null;
      }

      // Create timer observable
      this.timer$ = interval(200);

      if (!this.timer$) {
        throw new Error('Timer observable is undefined');
      }

      // Subscribe to the timer to simulate progress
      this.sub = this.timer$
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (sec) => {
            this.progressBar = sec;
          },
          error: (err) => {
            this.errorHandlerService?.logError('Spinner timer error', err);
            this.spinnerAnimation = false;
          },
        });

    } catch (error) {
      // Global fallback in case something goes wrong
      this.spinnerAnimation = false;
      this.errorHandlerService?.logError('Failed to start spinner', error);
    }
  }


  onCell1CountryChange(event) {
    // Extract event data outside Angular zone to prevent Java bridge errors on Android WebView
    this.countryCode = event?.iso2;
    this.newDialCode = event?.dialCode;
    
    // Process the form update inside Angular zone to ensure proper event handling
    this.ngZone.run(() => {
      this.createAccountForm.get("dialCode").setValue(this.newDialCode);
    });
  }
  openForgetPassword() {
    const forgotPasswordDialog = this.bottomSheet?.open(ForgotPasswordPage, {
      panelClass: "forgot-password-bottomsheet",
      hasBackdrop: true,
      disableClose: true,
      backdropClass: "about-product-dialog-backdrop",
      data: {
        countryCode: this.countryCode,
        mobileNumber: this.createAccountForm.get("phoneNumber").value,
      },
    });
    forgotPasswordDialog
      .afterDismissed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res: Data) => {
          if (res === undefined) {
            return;
          }
          if (res) {
            this.openVerifyPhoneNumber(res);
          }
        },
        error: (err) => {
          // Optional: handle error appropriately
          this.errorHandlerService.logError('Error in afterDismissed:', err);

        }
      });

  }

  openVerifyPhoneNumber(res) {
    this.msn = res.msn;
    const verifyPhoneNoBottomSheet = this.bottomSheet.open(VerifyPhoneNumberComponent, {
      panelClass: "verify-phone-number-bottom-sheet",
      data: {
        msn: res.msn,
        type: "signin",
        loginWithMsn: true,
      },
    });

    verifyPhoneNoBottomSheet
      .afterDismissed()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          if (data) {
            this.msn = data?.data?.msn ?? res?.msn;
            if (data?.data?.spoof_msn) {
              this.isSpoofMsn = data?.data?.spoof_msn;
            }
            if (data?.data?.uid) {
              this.uid = data?.data?.uid;
            }
            if (data?.resetToken) {
              this.resetToken = data.resetToken;
            }
            this.resetPassword();
          } else if (data === false) {
            this.partialRegistrationHelperService.otpSent();
            this.errorHandlerService.showTranslatedMessage("1010", {
              message: {
                line_1: "That verification code is incorrect. Check the code and try again.",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            });
          }
        },
        error: (err) => {
          this.errorHandlerService.logError('Error in verifyPhoneNoBottomSheet.afterDismissed:', err);

        }
      });

  }

  resetPassword(): void {
    this.bottomSheet.open(ResetPasswordPopupComponent, {
      disableClose: true,
      data: { msn: this.msn, resetToken: this.resetToken },
    });
  }

  updatePartialSetting() {
    let userID = this.partialRegistrationHelperService.getUserId();
    if (userID == null || userID == undefined) throw new Error("User ID is missing");
    this.AuthPartialRegService.updatePartialMsgRequest(true, true, userID)
      ?.pipe(takeUntil(this.unsubscribe$))
      ?.subscribe(
        (res) => {
          if (res && res?.response && res?.response.status === "success") {
            if (res && res?.status === "success") {
              return true;
            }
          }
        },
        (err) => {
          return err;
        }
      )
      .catch((error) => {
        throw new Error(`Error in updatePartialMsgRequest function ${error}`);
      });
  }

  flagsDropdownToggle(value: boolean) {
    CommonVariable.flagsDropdownOpened = value;
  }

  telInputObject(event: Data) {
    // Defensive check to prevent race condition where intl-tel-input's internal state
    // object 's' is undefined during library initialization (specifically on iOS/Firefox)
    if (!event || typeof event !== 'object') {
      this.dialCode = "44";
      return;
    }
    
    // Check if the internal state object exists before accessing properties
    if (event.s && typeof event.s === 'object' && event.s.dialCode) {
      this.dialCode = event.s.dialCode;
    } else {
      this.dialCode = "44";
    }
  }

  checkInput(e) {
    let value;
    const currentInput = e?.target?.value ?? this.ipstackCountryCode;
    const DEFAULT_VALUE = "+";
    const currentInputDefaultPart = currentInput.substring(0, DEFAULT_VALUE?.length);
    // check if the default part is no longer same as DEFAULT
    if (currentInputDefaultPart !== DEFAULT_VALUE) {
      // reset
      value = currentInput.length > 0 ? this.ipstackCountryCode : DEFAULT_VALUE;
      this.createAccountForm.get("dialCode").setValue(value);
    }
  }


  private scheduleCheckoutSdkPreload(): void {
    this.cancelCheckoutSdkPreload?.();
    if (this.checkoutSdkPreloadStarted) return;

    this.ngZone.runOutsideAngular(() => {
      let cancelled = false;
      let frameId: number;
      let idleId: number | undefined;
      let timerId: number | undefined;
      this.cancelCheckoutSdkPreload = () => {
        cancelled = true;
        window.cancelAnimationFrame(frameId);
        if (idleId !== undefined) window.cancelIdleCallback?.(idleId);
        if (timerId !== undefined) window.clearTimeout(timerId);
      };

      const preload = async () => {
        if (cancelled || this.isLoading || this.loadingError ||
            !this.el.nativeElement.querySelector('form')) return;
        try {
          // Keep the service and SDK off the registration form's initial render path.
          const { CheckoutFlowService } = await import('../../../services/checkout-flow.service');
          if (cancelled) return;
          this.checkoutSdkPreloadStarted = true;
          await this.injector.get(CheckoutFlowService).preloadSdk();
        } catch {
          // Optional warmup must not affect registration; payment can retry the load.
          this.checkoutSdkPreloadStarted = false;
        }
      };

      frameId = window.requestAnimationFrame(() => {
        if (cancelled) return;
        if (typeof window.requestIdleCallback === 'function') {
          idleId = window.requestIdleCallback(() => { void preload(); }, { timeout: 2000 });
        } else {
          timerId = window.setTimeout(() => { void preload(); }, 1);
        }
      });
    });
  }

  ngAfterViewInit() {
    this.scheduleCheckoutSdkPreload();
    try {
      void this.initializeTurnstile();

      // STEP 1: Initial UI adjustments
      // Delay execution to allow intl-tel-input library to fully initialize and prevent race condition
      setTimeout(() => {
        this.hideElements();
        this.updateContainerStyle();
      }, 100);

      // STEP 2: Handle query parameters for currency and language
      try {
        this.queryParamsSubscription = this.route.queryParams
          .pipe(takeUntil(this.destroy$))
          .subscribe((data: Data) => {
            if (data?.currency) {
              this.selectedCurrency = data.currency.toUpperCase();
              this.selectChange(this.selectedCurrency, true);
            }

            if (data?.lang) {
              this.selectedLanguage = data.lang.toLowerCase();
              if (allLanguageCodes.includes(this.selectedLanguage as Language)) {
                this.onLanguageChange(this.selectedLanguage as Language, true);
              }
              this.languageParamState = true;
            }
          });
      } catch (err) {
        return err;
      }
      this.handleSessionReload()
    } catch (error) {
      return error;
    }
  }

  private async initializeTurnstile(): Promise<void> {
    if (!this.turnstileEnabled) {
      return;
    }

    if (!this.turnstileInitPromise) {
      this.turnstileInitPromise = this.loadAndRenderTurnstile();
    }

    return this.turnstileInitPromise;
  }

  private async loadAndRenderTurnstile(): Promise<void> {
    try {
      await this.resourceLoader.loadTurnstile();
      await new Promise((resolve) => window.setTimeout(resolve, 0));
      this.renderTurnstileWidget();
      this.turnstileReady = this.turnstileWidgetId !== null;
    } catch (error) {
      this.turnstileInitPromise = null;
      this.errorHandlerService.logError('Turnstile load failed', error);
      throw error;
    }
  }

  private renderTurnstileWidget(): void {
    this.ngZone.run(() => {
      try {
        if (!this.turnstileEnabled || this.turnstileWidgetId !== null) {
          return;
        }

        if (!this.containerRef?.nativeElement) {
          this.errorHandlerService.logError('Turnstile container element not found');
          return;
        }

        this.turnstileWidgetId = turnstile?.render(this.containerRef?.nativeElement, {
          sitekey: this.turnstileSiteKey,
          size: 'normal',
          theme: 'light',
          callback: (token: string) => {
            this.turnstileToken = token;
          },
        });
      } catch (error) {
        this.errorHandlerService.logError('Turnstile initialization error:', error);
      }
    });
  }

  /**
  * Execute Turnstile challenge before form submission
  * Implements robust error handling and retry logic to prevent cross-origin errors
  */
  private async executeTurnstileChallenge(): Promise<string | null> {
    if (!this.turnstileEnabled) return 'bypass';

    try {
      await this.initializeTurnstile();

      if (this.turnstileWidgetId === null) {
        this.renderTurnstileWidget();
      }

      // Reset any existing token
      this.turnstileToken = null;

      // Execute the invisible challenge
      if ((window as Data).turnstile && this.turnstileWidgetId !== null) {
        // Reset the widget before executing to prevent "already executing" race condition
        // This is critical on poor connections where the previous execution may still be in progress
        try {
          (window as Data).turnstile.reset(this.turnstileWidgetId);
        } catch (resetError) {
          // Log but continue - reset may fail if widget is in certain states
          this.errorHandlerService.logError('Turnstile reset failed (non-critical):', resetError);
        }

        await (window as Data).turnstile.execute(this.turnstileWidgetId);

        // Wait for token with timeout
        const tokenTimeout = 10000; // 10 seconds
        const startTime = Date.now();

        while (!this.turnstileToken && (Date.now() - startTime) < tokenTimeout) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        if (!this.turnstileToken) {
          throw new Error('Turnstile challenge timeout');
        }

        return this.turnstileToken;
      } else {
        throw new Error('Turnstile not initialized');
      }
    } catch (error) {
      this.errorHandlerService.logError('Turnstile execution failed:', error);
      return null;
    }
  }


  private hideElements() {
    // Add null check for nativeElement to prevent race condition errors
    if (!this.el?.nativeElement) return;

    const elementsToHide = this.el.nativeElement.querySelectorAll(".iti__flag.iti__gb");
    
    // Check if querySelectorAll returned valid results
    if (elementsToHide && elementsToHide.length > 0) {
      elementsToHide.forEach((element) => {
        // Add defensive null check before accessing style property
        if (element) {
          const htmlElement = element as HTMLElement;
          if (htmlElement?.style) {
            htmlElement.style.setProperty("display", "none", "important");
          }
        }
      });
    }

    // Set a specific width for the container
    const container = this.el.nativeElement.querySelector(".iti.iti--allow-dropdown");
    if (container) {
      const containerElement = container as HTMLElement;
      // Add null check for style property before setting width
      if (containerElement?.style) {
        containerElement.style.width = "10%";
      }
    }
  }

  updateContainerStyle(): void {
    // Add null check for nativeElement to prevent race condition errors
    if (!this.el?.nativeElement) return;

    const container = this.el.nativeElement.querySelector(
      ".iti--allow-dropdown .iti__flag-container, .iti--separate-dial-code .iti__flag-container"
    );

    // Add defensive null check before accessing renderer
    if (container && this.renderer) {
      this.renderer.setStyle(container, "right", "20%");
    }
  }

  getSocialUser(socialUser): Data {
    const accountFormValue = this.createAccountForm.value;
    return {
      email: socialUser?.email,
      voucher_code: accountFormValue.voucher_code,
      agreeToTerms: accountFormValue.agreeToTerms ?? true,
      preferenceTick: accountFormValue?.preferenceTick ?? false,
      prosub_id: this.prosub_id ? this.prosub_id : this.default_prosub_id,
      language_code: this.authService?.selectedlanguage$?.value ?? defaultLanguage,
      preferred_currency: this.userManagementService?.selectedCurrency,
      password: this.partialRegistrationHelperService.getSocialPassword(),
      tp1: this.tp1,
      tp2: this.tp2,
      tp3: this.tp3,
      t_id: this.t_id,
      other: this.other,
    };
  }

  updateCurrencyAndReturnPayload(user): Data {
    let currency = this.userManagementService?.selectedCurrency;
    this.partialRegistrationHelperService.setPreferredCurrency(this.prosubIntPrice, this.prosubPrice);

    return {
      prosub_id: this.prosub_id,
      TP1: this.tp1,
      TP2: this.tp2,
      TP3: this.tp3,
      T_ID: this.t_id,
      offer_id: user?.offer_id ?? this.prosubOfferId ?? "",
      value: user?.value ?? this.prosubPrice ?? "",
      preferred_currency: {
        Value: String(
          this.prosubIntPrice?.[currency]
            ? this.prosubIntPrice?.[currency]?.toFixed(2)
            : this.prosubPrice
              ? this.prosubPrice?.toFixed(2)
              : 0
        ),
        currency: currency ?? "",
      },
      p_type: user?.p_type ?? "10",
      product_description: user?.product_description ?? "",
      other: this.other ?? "",
    };
  }

  successCallback(signInSuccessData: FirebaseUISignInSuccessWithAuthResult) {
    const socialUser = signInSuccessData?.authResult?.user?.providerData?.[0];
    const user = this.getSocialUser(socialUser);

    this.registerUser(user, socialUser, signInSuccessData?.authResult);

    this.safeLocalStorage.setItem("providerId", socialUser?.providerId);
    this.safeLocalStorage.setItem("preferenceTick", user?.preferenceTick);
    this.safeLocalStorage.setItem("proSub", "proSub");
  }

  async registerUser(user, socialUser, originalData) {
    let tempUser = null;

    try {
      // STEP 1: Handle existing user session
      // Check if a user is already logged in and remove them if not a dummy (DFCI) user
      let uid: string | undefined;
      try {
        const userAuth = await this.safeFirebaseOperation(
          () => this.authService?.getCurrentLoggedinUser(),
          undefined,
          'getCurrentLoggedinUser'
        );
        uid = userAuth?.uid;

        if (uid && !uid.startsWith("DFCI")) {
          await this.safeFirebaseOperation(
            () => userAuth?.delete(),
            undefined,
            'deleteCurrentUser'
          );
        }
      } catch (err) {
        throw new Error("We couldn't complete social sign-up. Try again.");
      }

      // Prepare the currency-based SQL payload
      const cp_request = this.updateCurrencyAndReturnPayload(user);

      // Add social user details into the user payload
      user = {
        ...user,
        socialUser: socialUser,
        social_id: socialUser?.uid,
        connect_type: socialUser?.providerId,
      };

      // STEP 2: Login anonymously to Firebase
      try {
        tempUser = await this.safeFirebaseOperation(
          () => this.authService.loginAnonymously(),
          null,
          'loginAnonymously'
        );
        if (!tempUser?.user?.uid) {
          throw new Error("We couldn't complete social sign-up. Try again.");
        }
        this.safeLocalStorage.setItem("anonymousId", tempUser.user.uid);
      } catch (err) {
        throw new Error("We couldn't complete social sign-up. Try again.");
      }

      // STEP 3: Give Firebase time to finalize auth state
      await new Promise((res) => setTimeout(res, 300));

      // STEP 4: Create user in SQL and proceed with checkout flow
      try {
        const result = await firstValueFrom(
          this.authService.createInstantUserInSql(user, tempUser.user.uid).pipe(take(1))
        );

        if (result?.response?.status === 'SUCCESS') {
          const loginService = this.injector.get(LoginDataResolverService);
          await loginService.insertCustomerPurchaseAndCreateCheckout(cp_request);
        } else {
          await this.cleanupAnonymousUser(tempUser);
          this.errorHandlerService.logError('User creation in SQL failed', result);
        }
      } catch (err) {
        await this.cleanupAnonymousUser(tempUser);
        this.errorHandlerService.logError('Could not finalize registration', err);
      }

      // STEP 5: Continue to post-registration sales logic (non-blocking)
      try {
        await new Promise((res) => setTimeout(res, 300));
        this.callSignupForSales(user, tempUser, originalData);
      } catch (err) {
        // Log sales logic failure but don't stop the flow
        this.errorHandlerService.logError('Sales signup failed:', err);
      }

    } catch (finalErr) {
      // Global error handler: clean up if necessary and show user-friendly message
      if (tempUser) {
        await this.safeFirebaseOperation(
          () => this.cleanupAnonymousUser(tempUser),
          undefined,
          'cleanupAnonymousUserOnFinalCatch'
        );
      }
      this.showUserError(finalErr?.message || "We couldn't complete social sign-up. Try again.");
    }
  }

  // Utility method to clean up anonymous Firebase user and clear local storage
  private async cleanupAnonymousUser(tempUser: any): Promise<void> {
    if (!tempUser?.user) return;

    try {
      await tempUser.user.delete();
      this.safeLocalStorage.removeItem("anonymousId");
    } catch (err) {
      this.errorHandlerService.logError('Failed to cleanup anonymous user', err);
    }
  }


  private showUserError(message: string) {
    this.errorHandlerService.showTranslatedMessage(null, {
      message: { line_1: message },
      style: {
        icon: "tick circle error.svg",
        type: "Error",
      },
    });
  }



  callSignupForSales(user, tempUser, originalData): void {
    // New social signup journey — clear any prior cached SQL customer_id.
    this.authService.resetRegistrationIdentityCache();
    const registrationIdentityEpoch = this.authService.captureRegistrationIdentityEpoch();
    this.authService
      .callSigUpForSales(user, tempUser?.user?.uid)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: Data) => {
          // Ignore stale signup responses from a prior journey epoch.
          if (!this.authService.applyRegistrationIdentityResponse(res, registrationIdentityEpoch)) {
            return;
          }
          if (res?.response?.status === "FAIL") {
            const providerLabel =
              user?.connect_type === "google.com"
                ? "Google"
                : user?.connect_type === "facebook.com"
                  ? "Facebook"
                  : user?.connect_type || "social";
            this.errorHandlerService.showTranslatedMessage(null, {
              message: {
                line_1: res?.response?.message || `We couldn't create your account with ${providerLabel}. Try again.`,
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            });
            this.authService?.logout().catch((error) => error);
            return;
          }
          this.partialRegistrationHelperService.storeUserID(res?.response?.user_id);

          if (res?.response?.status === "SUCCESS" && res?.response?.customer_id) {
            // this.updateSocialData(user, originalData);

            user.firstName = originalData?.additionalUserInfo?.profile?.given_name;
            user.lastName = originalData?.additionalUserInfo?.profile?.family_name;

            // this.createFbUser(user, res?.response, tempUser);
            this.checkIfUserIdExist(user, res?.response, tempUser, originalData);
          }
        },
        (err) => {
          return err;
        }
      );
  }

  checkIfUserIdExist(user, response, tempUser, originalData): void {
    const userId = response?.user_id || this.partialRegistrationHelperService.getUserId();
    this.authService
      .getAngularFireStore(`users/${userId}`, "get")
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: Data) => {
          const userData = data?.data();
          const exists = !!data?.exists;
          this.isSameLoginTime = userData?.last_login_datetime?.seconds === userData?.previous_login_datetime?.seconds;
          this.createFbUser(user, response, tempUser, originalData, exists);
        },
        error: (error) => {
          return error;
        },
      });
  }

  createFbUser(user: CreateUser, response: Data, tempUser: Data, originalData: Data, existingUser: boolean): void {
    this.authService
      .createFbUser(user, response, existingUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (createFbUserRes: Data) => {
          if (createFbUserRes && createFbUserRes?.success && createFbUserRes?.customToken) {
            this.updateSocialData(user, originalData, existingUser);
            this.authService
              .completeAnonymousSalesJourneyLogin(tempUser, createFbUserRes?.customToken)
              .catch((error) => this.authService.errorHandlerLogs(error));
          } else {
            return createFbUserRes?.message;
          }
        },
        (err) => {
          return err;
        }
      );
  }

  updateSocialData(user: Data, originalData: Data, alreadyExist?: boolean): void {
    this.authService
      ?.updateUserSocialTokenDetails(user, originalData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value: Data) => {
          if (value) {
            this.successfulRegistration(alreadyExist || false);
          }
        },
        error: (error) => {
          return error;
        },
      });
  }

  successfulRegistration(alreadyExist: boolean): void {
    if (alreadyExist && !this.isSameLoginTime) {
      this.errorHandlerService.showTranslatedMessage("1077", {
        message: {
          line_1: "You already have an account. We're logging you in.",
        },
        style: {
          icon: "tick circle success.png",
          type: "Success",
        },
      });
    }
    this.matDialog.closeAll();
    this.progressBar = 100;
    // Returning / already-registered users skip Account Created and go to the offer's 4C page.
    const nextPage = alreadyExist
      ? this.resolveExistingUserNextPage()
      : ((this.GTMService?.prosubDetails?.optional_page as string) || "/account-created");
    this.uploadUserFingerprintInfo();
    this.router.navigate([nextPage], {
      queryParams: {
        prosub_id: this.prosub_id,
        ...this.GTMServise.queryParamsToNavigate,
        vc: this.vc,
        TP1: this.tp1 ? this.tp1 : "null",
        TP2: this.tp2 ? this.tp2 : "null",
        TP3: this.tp3 ? this.tp3 : "null",
        T_ID: this.t_id ? this.t_id : "",
        Other: this.other ? this.other : "",
        upsell_ID: this.upsell_ID ? this.upsell_ID : "",
        call_from: this.callFromPromotion,
        gc: this.gc || "",
        pt: this.pt || "",
      },
    });
  }

  errorCallback(errorData: FirebaseUISignInFailure) {
    this.errorHandlerService.logError('ERROR:', errorData);

  }

  uiShownCallback() {
    try {
      const { operatingSystem } = CommonVariable?.device || {};
      if (operatingSystem !== "ios" && operatingSystem !== "mac") {
        // Defer DOM manipulation to ensure Firebase UI elements are fully rendered
        // This prevents race conditions on Android devices with slower network/rendering
        const elements = document?.getElementsByClassName("firebaseui-idp-generic");

        // Proper check: getElementsByClassName returns HTMLCollection which is always truthy
        // Check if it has any elements instead
        if (!elements || elements.length === 0) return;

        Array.from(elements).forEach((element: Element) => {
          try {
            // Defensive check: ensure element exists and is an HTMLElement
            if (!element || !(element instanceof HTMLElement)) return;

            const providerId = element?.getAttribute("data-provider-id") || "";

            // Defensive check: ensure style property exists before accessing it
            const elementStyle = (element as HTMLElement)?.style;
            if (!elementStyle) return;

            // Safe to set display property now
            elementStyle.display = providerId?.includes("apple") ? "none" : "inline";
          } catch (error) {
            // Log error but don't propagate to prevent breaking the UI
            this.errorHandlerService?.logError?.('Error modifying Firebase UI button style', error);
          }
        });
      }
    } catch (error) {
      // Log error but don't propagate to prevent breaking the UI
      this.errorHandlerService?.logError?.('Error in uiShownCallback', error);
    }
  }

  ngOnDestroy() {
    this.cancelCheckoutSdkPreload?.();
    this.destroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
    this.clearSubscriptions();
    this.clearPendingTimers();
  }

  ionViewWillEnter() {
    // Reactivate the view flag when navigating back to a cached Ionic page.
    // Subscriptions are reinstated here to cover the case where ionViewWillLeave()
    // cleared them without the component being destroyed.
    this.isViewActive = true;
    this.initSubscriptions();

    // If a prior init attempt aborted mid-yield while the page was cached,
    // restart the critical path. Skip on the initial enter that races with
    // ngOnInit (needsInitRestart is only set on abort/leave).
    if (this.needsInitRestart && !this.destroyed) {
      this.needsInitRestart = false;
      void this.runCriticalInitialization();
    }
  }

  ionViewWillLeave() {
    this.cancelCheckoutSdkPreload?.();
    // Invalidate the view-active flag so that any in-flight async continuation
    // from ngOnInit / initializeCriticalData / initializeFormWithDefaults that
    // resumes after this point will bail out rather than continue initializing
    // a view that is no longer on screen. (Ionic can cache pages and call this
    // without destroying the component, so checking only `destroyed` is insufficient.)
    this.isViewActive = false;
    if (!this.initCompleted) {
      this.needsInitRestart = true;
    }
    this.clearSubscriptions();
    // Cancel any pending macrotask timers so deferred callbacks do not run
    // against an inactive view.
    this.clearPendingTimers();
  }

  /**
   * True while this view is on screen. Set to true in ngOnInit/ionViewWillEnter
   * and false in ionViewWillLeave. Checked after every async yield and before
   * scheduling fire-and-forget timers to prevent work running on a cached/inactive page.
   */
  private isViewActive = false;

  /**
   * True once critical initialization (including form defaults + deferred secondary
   * scheduling) has completed while the view was active. Used with needsInitRestart
   * so ionViewWillEnter can resume work aborted by Ionic page caching.
   */
  private initCompleted = false;

  /**
   * Set when init aborts because the view left / became inactive before completion.
   * ionViewWillEnter checks this so the first-load race with ngOnInit does not
   * start a duplicate initialization.
   */
  private needsInitRestart = false;

  /** Timer ID for the fire-and-forget selectedlanguage$.next() macrotask yield. */
  private langNotifyTimerId: ReturnType<typeof setTimeout> | null = null;
  /** Timer ID for the fire-and-forget secondary init macrotask yield. */
  private secondaryInitTimerId: ReturnType<typeof setTimeout> | null = null;
  /** Timer ID for the deferred BehaviorSubject emissions in onLanguageChange(). */
  private langChangeNotifyTimerId: ReturnType<typeof setTimeout> | null = null;

  /** Cancels any pending fire-and-forget macrotask timers. Safe to call multiple times. */
  private clearPendingTimers(): void {
    if (this.langNotifyTimerId !== null) {
      clearTimeout(this.langNotifyTimerId);
      this.langNotifyTimerId = null;
    }
    if (this.secondaryInitTimerId !== null) {
      clearTimeout(this.secondaryInitTimerId);
      this.secondaryInitTimerId = null;
    }
    if (this.langChangeNotifyTimerId !== null) {
      clearTimeout(this.langChangeNotifyTimerId);
      this.langChangeNotifyTimerId = null;
    }
  }

  private isRetrying = false;

  retry(): void {
    // Guard against re-entrant retries (e.g. rapid taps on WebKit/iPhone)
    if (this.isRetrying) return;
    this.isRetrying = true;

    this.isLoading = true;
    this.loadingError = false;
    this.errorMessage = '';
    this.initCompleted = false;
    this.needsInitRestart = false;

    this.clearSubscriptions();
    this.scheduleCheckoutSdkPreload();

    // Reset Subjects that were completed by clearSubscriptions() so that
    // takeUntil(this.unsubscribe$) / takeUntil(this.destroy$) pipes work
    // correctly on the next initialisation cycle.
    this.unsubscribe$ = new Subject<void>();
    this.destroy$ = new Subject<void>();
    this.destroyed = false;

    // Use setTimeout(0) to schedule re-initialisation as a macrotask. This
    // unwinds the current call stack before ngOnInit runs, preventing the
    // deep synchronous execution that causes "Maximum call stack size exceeded"
    // (and the secondary "Error: fa") on WebKit / iPhone.
    setTimeout(() => {
      this.isRetrying = false;
      this.ngOnInit();
    }, 0);
  }

  private loadLanguageData(): Promise<void> {
    return new Promise((resolve) => {
      this.loadLanguageDataSubscription = this.partialRegistrationHelperService
        .getLanguageList()
        .pipe(
          timeout(5000),
          take(1),
          catchError(err => {
            this.errorHandlerService.logError('Language load failed', err);
            return of({ languages: [this.DEFAULT_ENGLISH_LANG] });
          })
        )
        .subscribe({
          next: (data) => {
            if (data?.languages?.length) {
              const languages = data.languages.filter(l => l.language_status);
              const english = languages.filter((lang) => lang?.language_code === "en");
              const rest = languages.filter((lang) => lang?.language_code !== "en");
              this.languageArray = languages.length
                ? [...english, ...rest]
                : [this.DEFAULT_ENGLISH_LANG];
            } else {
              this.languageArray = [this.DEFAULT_ENGLISH_LANG];
            }
            resolve();
          },
          error: () => resolve()
        });
    });
  }

  private loadCurrencyData(): Promise<void> {
    return new Promise((resolve) => {
      this.loadCurrencyDataSubscription = this.authService?.getCurrencyList$
        ?.pipe(
          timeout(5000),
          take(1),
          takeUntil(this.destroy$),
          catchError(err => {
            this.errorHandlerService.logError('Currency load failed', err);
            return of({ details: [this.DEFAULT_GBP_CURRENCY] });
          })
        )
        ?.subscribe({
          next: (data: Data) => {
            const currencies = data?.details?.filter((currency) => currency?.status) ?? [];
            if (!currencies.length) {
              this.currencyArray = this.partialRegistrationHelperService.getSelectedCurrency(
                [this.DEFAULT_GBP_CURRENCY],
                this.selectedCurrency || "GBP"
              );
              resolve();
              return;
            }
            const activeCodes = currencies.map((currency) => currency?.currency_code).filter(Boolean);
            // If stored/selected currency is not an active currency, fall back to GBP.
            if (activeCodes.length > 0 && !activeCodes.includes(this.selectedCurrency)) {
              this.setOfferCurrency("GBP");
            }
            const gbp = currencies.filter((currency) => currency?.currency_code === "GBP");
            const rest = currencies.filter((currency) => currency?.currency_code !== "GBP");
            this.currencyArray = this.partialRegistrationHelperService.getSelectedCurrency(
              [...gbp, ...rest],
              this.selectedCurrency
            );
            resolve();
          },
          error: () => resolve()
        });
    });
  }

  private getTranslation(key: string, fallback: string): string {
    return this.translate.instant(key) !== key ? this.translate.instant(key) : fallback;
  }

  /** Unsubscribes view-scoped subscriptions installed by initSubscriptions(). */
  private clearViewSubscriptions(): void {
    this.selectedlanguageSubscription?.unsubscribe();
    this.constantsMsgSubscription?.unsubscribe();
    this.userDetailsSubscription?.unsubscribe();
    this.wrongPasswordSubscription?.unsubscribe();
    this.incorrectAttemptSubscription?.unsubscribe();
  }

  private clearSubscriptions(): void {
    this.unsubscribe$?.next();
    this.unsubscribe$?.complete();
    this.prosubDetailsSubscription?.unsubscribe();
    this.queryParamsSubscription?.unsubscribe();
    this.clearViewSubscriptions();
    this.activeCurrencyListSubscription?.unsubscribe();
    this.loadLanguageDataSubscription?.unsubscribe();
    this.loadCurrencyDataSubscription?.unsubscribe();
  }

  private resetSpinnerState(): void {
    this.spinnerAnimation = false;
    this.sub?.unsubscribe();
  }

  // Standardized error handler
  private handleError(
    error: Data,
    options: { showToast?: boolean; resetSpinner?: boolean; customAction?: () => void } = {}
  ): void {
    const { showToast = true, resetSpinner = true, customAction } = options;

    if (resetSpinner) {
      this.resetSpinnerState();
    }

    let errorMessage =
      typeof error === "string"
        ? error
        : error?.message?.replace(/FirebaseError:?\s*/i, "") || "We couldn't create your account. Try again.";

    if (errorMessage.includes("This user is already registered, please login with correct password")) {
      this.wrongLoginAttempt++;
      if (this.wrongLoginAttempt >= 1) {
        this.openForgetPassword();
      }
      this.wrongCredentialMatched = true;
    }

    if (showToast) {
      this.errorHandlerService.showTranslatedMessage(null, {
        message: { line_1: errorMessage },
        style: { icon: "tick circle error.svg", type: "Error" },
      });
    }

    customAction?.();
  }

  private firestoreWithTimeout<T>(
    observable: Observable<T>,
    timeoutMs: number = 5000,
    fallbackValue: T
  ): Observable<T> {
    return observable.pipe(
      timeout(timeoutMs),
      catchError(err => {
        this.errorHandlerService.logError('Firestore operation timed out', err);
        return of(fallbackValue);
      })
    );
  }


  // Enhancements component================================================

  private async loadEnhancementsInBackground(): Promise<void> {
    // Track enhancement loading
    this.enhancementsLoading = true;

    try {
      // Defer IP location lookup to run AFTER initial render to avoid blocking LCP
      // Push to next event loop tick to prioritize critical rendering
      setTimeout(() => {
        try {
          this.loadIPLocationData();
        } catch (err) {
          this.errorHandlerService.logError('loadIPLocationData error', err);
        }
      }, 0);

      // Setup listeners — each wrapped individually so one failure doesn't block the others
      try { this.setupNetworkListener(); } catch (err) {
        this.errorHandlerService.logError('setupNetworkListener error', err);
      }
      try { this.setupLanguageSubscriptions(); } catch (err) {
        this.errorHandlerService.logError('setupLanguageSubscriptions error', err);
      }
      try { this.setupConnectionMonitoring(); } catch (err) {
        this.errorHandlerService.logError('setupConnectionMonitoring error', err);
      }

      // Parallel load all enhancements (all non-blocking)
      const enhancementPromises = [
        this.loadFullLanguageList(),
        this.loadProsubDetails(),
        this.loadTrackingData(),
        this.loadCurrencyData()
      ];

      // Fire and forget - don't block
      Promise.allSettled(enhancementPromises)
        .then(() => this.onEnhancementsLoaded())
        .finally(() => this.enhancementsLoading = false);

      // Process query parameters for navigation (synchronous)
      this.processNavigationParams();

      // loadIPLocationData is already deferred via setTimeout above (line ~2407);
      // the duplicate direct call here has been removed to prevent a double fetch.

    } catch (error) {
      this.errorHandlerService.logError('Enhancement loading error', error);
      this.enhancementsLoading = false;
    }
  }

  private setupLanguageSubscriptions(): void {
    this.authService.selectedlanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedLanguage) => {
        if (!this.flag?.length) return;

        const selectedFlag = this.flag.find(flag => flag.country_code === selectedLanguage);
        this.selectedFlag =
          selectedFlag || this.flag.find(flag => flag.country_code === defaultLanguage) || this.flag[0];
      });
  }
  private setupNetworkListener(): void {
    Network.addListener("networkStatusChange", (e) => {
      if (e.connected) {
        this.isOnline = true;
        this.errorHandlerService.showTranslatedMessage(null, {
          message: { line_1: "You're back online. Registration can continue." },
          style: { icon: "tick circle success.png", type: "Success" },
        });
      } else {
        this.isOnline = false;
        this.errorHandlerService.showTranslatedMessage(null, {
          message: { line_1: "You're offline. We'll save your registration and finish it when you're back online." },
          style: { icon: "tick circle info.svg", type: "Info" },
        });
      }
    });
  }

  private async loadTrackingData(): Promise<void> {
    try {
      this.GTMService.collectVisitorData();
    } catch (err) {
      this.errorHandlerService.logError('Tracking setup failed', err);
    }
  }


  private async loadProsubDetails(): Promise<void> {
    // Define fallback values to ensure consistent defaults
    const fallbackData = {
      free_reg_mod_id: null,
      optional_page: '/account-created',
      create_account_opt_msg: '',
      offer_id: null,
      price: 0,
      int_price: {}
    };

    // Early return with fallback data if prosub_id is not available
    // This prevents unauthenticated Cloud Function calls during initialization
    if (!this.prosub_id) {
      // Set fallback values immediately without making Cloud Function call
      this.prosubOfferId = fallbackData.offer_id;
      this.prosubPrice = fallbackData.price;
      this.prosubIntPrice = fallbackData.int_price;
      return;
    }

    const path_id = "ERzajuwYcQgv2qQ1tA9q";
    const dv = { docId: this.prosub_id };
    const method = "read";

    this.prosubDetailsSubscription = this.firestoreWithTimeout(
      // docData(docRef).pipe(take(1)),
      this.authService.getV2CloudFunction("updatefirestoredoc", {
        path_id,
        dv,
        method,
      }).pipe(
        map((snapshot: any) => snapshot?.data),
        catchError(err => {
          this.errorHandlerService.logError('updatefirestoredoc call failed in loadProsubDetails', err);
          return of(fallbackData);
        })
      ),
      5000,
      fallbackData
    ).pipe(
      takeUntil(this.destroy$),
      catchError(err => {
        this.errorHandlerService.logError('Prosub details loading failed, using fallback', err);
        return of(fallbackData);
      })
    )
      .subscribe({
        next: (data: Data) => {
          // Guard against undefined/null data from Firestore connection errors
          // This prevents "undefined is not an object" errors on poor network connections
          if (!data || typeof data !== 'object') {
            this.errorHandlerService.logError('Prosub details data is undefined or invalid, using fallback values');
            data = fallbackData;
          }

          // Ensure we always set values with proper fallbacks to prevent null/undefined access
          this.prosubOfferId = data.offer_id ?? null;
          this.prosubPrice = data.price ?? 0;
          this.prosubIntPrice = data.int_price ?? {};

          // Keep GTM prosubDetails in sync so existing-user / continue redirects can read optional_page.
          // Do not overwrite with the local fallback (optional_page=/account-created) when Firestore failed.
          if (data !== fallbackData) {
            this.GTMService.prosubDetails = {
              ...(this.GTMService.prosubDetails || {}),
              ...data,
            };
            if (this.GTMServise) {
              this.GTMServise.prosubDetails = {
                ...(this.GTMServise.prosubDetails || {}),
                ...data,
              };
            }
          }

          if (data.free_reg_mod_id === 9) this.socialLogin = true;

          const optionalPage = data?.optional_page ? String(data.optional_page).split("?")[0] : "";
          if (
            this.authService.autoUserId &&
            optionalPage &&
            optionalPage.indexOf("partial-registration") < 0
          ) {
            const queryParams = canonicalizeProsubQueryParams({
              ...this.route.snapshot.queryParams,
            });
            delete queryParams["token"];
            delete queryParams["t"];
            delete queryParams["T"];
            this.router.navigate([optionalPage], { queryParams });
            return;
          }

          // ✅ FIX: Defer the 38KB HTML fetch (partial_Reg) to prevent render blocking
          // This call was previously synchronous inside this subscription, causing a nested
          // dependency chain that blocked the page from rendering.
          // Now we schedule it to run AFTER the critical render path completes.
          setTimeout(() => {
            this.loadLandingPageData(data);
          }, 100); // 100ms delay ensures initial render completes first
        },
        error: err => this.errorHandlerService.logError('Failed to load prosub details subscription:', err)
      });
  }

  /**
   * ✅ FIX for "Large Render Blocking Asset" issue
   * 
   * Loads the landing page HTML content (38KB from partialregv2 Cloud Function)
   * This method is called asynchronously with a delay to prevent blocking the initial render
   * 
   * BEFORE: This was nested inside loadProsubDetails() subscription, creating a synchronous
   *         dependency chain that blocked page rendering
   * AFTER: Now called via setTimeout() to defer execution until after initial render completes
   * 
   * @param prosubData - The prosub configuration data needed to determine which HTML to load
   */
  private loadLandingPageData(prosubData: Data): void {
    if (!this.prosub_id) return;

    this.AuthPartialRegService.partial_Reg(this.prosub_id, '', '', "landing")
      .pipe(
        takeUntil(this.destroy$),
        catchError(err => {
          this.errorHandlerService.logError('partial_Reg call failed:', err);
          // Return null to gracefully handle errors without breaking the page
          return of(null);
        })
      )
      .subscribe({
        next: (s) => {
          // If the API call fails or returns no data, keep landingPageData empty
          if (!s) return;

          const optMsgContent = s?.getRegOptMsgHtml || s?.getRegOptMsgHtml?.[0];
          const isNewOptMsg = this.alternateOptMsgBasedOn4x || s?.prosubDetail?.free_reg_mod_id === CommonVariable.partialRegCheckForNewOptMsg;

          // Determine which HTML content to display based on configuration
          this.landingPageData = isNewOptMsg && optMsgContent
            ? optMsgContent
            : (prosubData.optional_page === 'free-reg-step4h' ? s?.createAccountHtml : (prosubData?.create_account_opt_msg ? s?.createAccountHtml : null));
        },
        error: err => {
          this.errorHandlerService.logError('partial_Reg subscription error:', err);
          // Keep landingPageData as empty string on error
        }
      });
  }





  private async loadFullLanguageList(): Promise<void> {
    return new Promise((resolve) => {
      this.loadLanguageDataSubscription = this.partialRegistrationHelperService
        .getLanguageList()
        .pipe(
          timeout(5000),
          take(1),
          catchError(err => {
            this.errorHandlerService.logError('Language list failed', err);
            return of({ languages: this.languageArray });
          })
        )
        .subscribe({
          next: (data) => {
            try {
              if (data?.languages?.length > 1) {
                const fullList = data.languages.filter(l => l.language_status);
                this.mergeLanguageList(fullList);
              }
            } catch (error) {
              this.errorHandlerService.logError('Error processing language list', error);
            }
            resolve();
          },
          error: (err) => {
            this.errorHandlerService.logError('Language list subscription error', err);
            resolve();
          }
        });
    });
  }

  private mergeLanguageList(fullList: Data[]): void {
    // Preserve current selection while expanding options
    const currentSelection = this.selectedLanguage;

    this.languageArray = this.partialRegistrationHelperService.getSelectedLanguage(
      fullList,
      currentSelection
    );

    // Ensure current selection exists in list without displacing English-first order
    if (!this.languageArray.find(l => l.language_code === currentSelection)) {
      const missingLang = {
        language_code: currentSelection,
        language_name: this.getLanguageName(currentSelection),
        selected: true,
        language_status: true
      };
      if (currentSelection === "en") {
        this.languageArray.unshift(missingLang);
      } else {
        this.languageArray.push(missingLang);
      }
    }
  }

  private async loadIPLocationData(): Promise<void> {
    // Skip if user already has explicit choice from URL or localStorage
    if (this.languageSource === 'url' || this.languageSource === 'storage') {
      return;
    }

    try {
      // Use cached data or create new fetch promise (prevent duplicate API calls)
      if (!this.ipDataCache && !this.ipDataFetchPromise) {
        this.ipDataFetchPromise = firstValueFrom(
          this.userManagementService.getUserCountryBaseOnIP().pipe(
            timeout(5000), // Increased timeout for background loading
            catchError(() => of(null))
          )
        );
        this.ipDataCache = await this.ipDataFetchPromise;
        this.ipDataFetchPromise = null;
      } else if (this.ipDataFetchPromise) {
        // Wait for existing fetch to complete
        this.ipDataCache = await this.ipDataFetchPromise;
      }

      const ipData = this.ipDataCache;
      if (!ipData) return;

      // Update dial code only if user hasn't interacted
      if (ipData?.location?.calling_code && !this.hasUserInteraction()) {
        const newDialCode = "+" + ipData.location.calling_code;
        const currentDialCode = this.createAccountForm?.get("dialCode")?.value;

        if (newDialCode !== currentDialCode && this.createAccountForm) {
          this.createAccountForm.get("dialCode").setValue(newDialCode);
          this.trackDialCodeUpdate("ip-detection", currentDialCode, newDialCode);
        }
      }
      // Removed smoothLanguageTransition() call - it was causing ReferenceError by bypassing
      // the intl-tel-input library's proper state management and extracting innerHTML directly
    } catch (error) {
      // Ignore IP detection failures (already in background)
      this.errorHandlerService.logError('Background IP detection failed', error);
    }
  }

  private async updateLanguageAndCurrencyFromIP(ipData: any): Promise<void> {
    try {
      const countryCode = ipData?.country_code ?? "GB";

      // Get language and currency mapping
      const mappingData = await firstValueFrom(
        this.authService.getCurrencyAndLanguageList$.pipe(
          timeout(3000),
          catchError(() => of({ GB: { language: "en", currency: "GBP" } }))
        )
      );

      const countryData = mappingData[countryCode] || mappingData["GB"];
      const ipLanguage = countryData?.language;
      const ipCurrency = countryData?.currency;

      // Only update if user hasn't started typing
      if (this.userStartedTyping()) return;

      // Update language if valid and different
      if (ipLanguage && allLanguageCodes.includes(ipLanguage as Language) &&
        ipLanguage !== this.selectedLanguage) {
        this.ipBasedUserLanguage = ipLanguage as Language;
        this.selectedLanguage = ipLanguage;
        this.languageSource = 'ip';

        // Apply language change
        this.authService.selectedlanguage$.next(this.selectedLanguage);
        localStorage.setItem("language_code", this.selectedLanguage);
        this.translate.use(this.selectedLanguage);

        // Update language array
        this.languageArray = this.partialRegistrationHelperService.getSelectedLanguage(
          this.languageArray,
          this.selectedLanguage
        );
      }

      // Update currency if valid and different
      if (ipCurrency && ipCurrency !== this.selectedCurrency &&
        this.currencySource !== 'url' && this.currencySource !== 'storage') {
        this.ipBasedUserCurrency = ipCurrency;
        this.selectedCurrency = ipCurrency;
        this.currencySource = 'ip';

        // Apply currency change
        localStorage.setItem("user_currency", this.selectedCurrency);
        this.selectChange(this.selectedCurrency);

        // Update currency array
        this.currencyArray = this.partialRegistrationHelperService.getSelectedCurrency(
          this.currencyArray,
          this.selectedCurrency
        );
      }

      // Update dial code based on new language/currency
      if (!this.userModifiedDialCode && this.createAccountForm) {
        const newDialCode = this.getSmartDefaultDialCode();
        const currentDialCode = this.createAccountForm.get("dialCode").value;
        if (newDialCode !== currentDialCode) {
          this.createAccountForm.get("dialCode").setValue(newDialCode);
        }
      }

    } catch (error) {
      this.errorHandlerService.logError('Failed to update language/currency from IP', error);
    }
  }


  private applyOfferState(state: { status: 'loading' | 'ready' | 'error'; data?: Data; error?: string }): void {
    this.offerState = state.status;
    this.offerError = state.error || '';
    if (state.status !== 'ready') return;

    const data = state.data;
    const detail = data?.prosubDetail;
    const offerId = Number(detail?.offer_id);
    const price = Number(detail?.price);
    const prosubId = String(detail?.prosub_id || '');
    if (!/^[1-9]\d*$/.test(prosubId) || !Number.isInteger(offerId) || offerId <= 0 ||
        !Number.isFinite(price) || price < 0 || !data?.modData) {
      this.offerState = 'error';
      this.offerError = 'Offer details are unavailable. Please retry.';
      return;
    }

    this.prosub_id = prosubId;
    this.prosubOfferId = offerId;
    this.prosubPrice = price;
    this.prosubIntPrice = detail.int_price || {};
    this.offerBaseCurrency = /^[A-Z]{3}$/.test(String(detail.currency || '').toUpperCase())
      ? String(detail.currency).toUpperCase() : 'GBP';
    if (!this.hasOfferCurrency()) this.setOfferCurrency(this.offerBaseCurrency);
    this.socialLogin = detail.free_reg_mod_id === 9;
    const currentEmail = this.createAccountForm?.get('email');
    const currentPhone = this.createAccountForm?.get('phoneNumber');
    const currentVoucher = this.createAccountForm?.get('voucher_code');
    this.checkForModules({
      ...data.modData,
      email: data.modData.email || currentEmail?.dirty,
      msn: data.modData.msn || currentPhone?.dirty,
      voucher: data.modData.voucher || currentVoucher?.dirty,
    });
    this.applyPendingIpCurrency();
    if (detail.create_account_opt_msg || detail.optional_page === 'free-reg-step4h' ||
      detail.free_reg_mod_id === CommonVariable.partialRegCheckForNewOptMsg || this.alternateOptMsgBasedOn4x) {
      setTimeout(() => {
        if (this.destroyed || !this.isViewActive) {
          return;
        }
        this.loadLandingPageData(detail);
      }, 0);
    }
  }

  retryOffer(): void {
    this.offerState = 'loading';
    this.offerError = '';
    this.loginDataResolver.startPartialRegistrationOffer(this.route.snapshot, undefined,
      { language: this.selectedLanguage, currency: this.selectedCurrency });
  }

  hasOfferCurrency(): boolean {
    if (this.selectedCurrency === this.offerBaseCurrency) return true;
    const price = this.prosubIntPrice?.[this.selectedCurrency];
    return price !== null && price !== undefined && price !== '' && Number.isFinite(Number(price));
  }

  private setOfferCurrency(currency: string): void {
    this.selectedCurrency = currency;
    this.userManagementService.selectedCurrency = currency;
    this.safeLocalStorage.setItem('user_currency', currency);
    this.currencyArray = this.partialRegistrationHelperService.getSelectedCurrency(
      this.currencyArray?.length ? this.currencyArray : [this.DEFAULT_GBP_CURRENCY],
      currency
    );
  }

  private applyPendingIpCurrency(): void {
    if (!this.pendingIpCurrency || this.initialDefaults?.hasUrlCurrency || this.hasUserInteraction()) return;
    const ipPrice = this.prosubIntPrice?.[this.pendingIpCurrency];
    if (ipPrice === null || ipPrice === undefined || ipPrice === '' || !Number.isFinite(Number(ipPrice))) return;
    this.setOfferCurrency(this.pendingIpCurrency);
    this.currencySource = 'ip';
    this.pendingIpCurrency = '';
  }

  private isTurnstileCanaryRoute(params: Data = this.route.snapshot.queryParams): boolean {
    const marker =
      params?.requires_turnstile ??
      params?.Requires_Turnstile ??
      params?.REQUIRES_TURNSTILE;
    return String(marker) === '1';
  }

  private hasUserInteraction(): boolean {
    if (!this.createAccountForm) return false;
    const phoneNumber = this.createAccountForm.get("phoneNumber");
    const activeElement = typeof document !== 'undefined' ? document.activeElement : null;
    return !!(this.createAccountForm.dirty || phoneNumber?.touched || phoneNumber?.value ||
      this.userModifiedDialCode || this.spinnerAnimation ||
      this.userSelectedLanguage || this.userSelectedCurrency ||
      (activeElement && this.el?.nativeElement?.contains(activeElement)));
  }

  private trackDialCodeUpdate(source: 'smart-default' | 'ip-detection', fromCode: string, toCode: string): void {
    this.GTMService?.trackEvent("dial_code_auto_update", {
      source: source,
      from_code: fromCode,
      to_code: toCode,
      time_since_load: performance.now(),
      user_had_interacted: this.hasUserInteraction(),
      language: this.selectedLanguage,
      currency: this.selectedCurrency,
    });
  }

  private shouldUpdateFromIP(ipData: Data): boolean {
    // Only update if:
    // 1. We used browser/default language
    // 2. IP suggests different language
    // 3. User hasn't started filling form

    return (this.languageSource === 'browser' || this.languageSource === 'default') &&
      ipData.language !== this.selectedLanguage &&
      !this.userStartedTyping();
  }

  /**
   * DEPRECATED & REMOVED: smoothLanguageTransition() method
   * 
   * This method was causing a ReferenceError: "Can't find variable: focusType"
   * 
   * ROOT CAUSE: It was extracting dial code from intl-tel-input library's internal DOM element
   * (.iti__selected-dial-code) and directly setting it to the form control using setValue().
   * This bypassed the library's proper state management and event handling, causing the library's
   * (countryChange) event handlers to receive malformed event objects that lacked the required
   * 'focusType' property.
   * 
   * PROPER APPROACH: If dial code manipulation is needed, use the intl-tel-input library's
   * proper API methods (like setCountry()) instead of extracting and manipulating raw HTML.
   */

  private onEnhancementsLoaded(): void {
    // Final selection updates
    this.languageArray = this.partialRegistrationHelperService.getSelectedLanguage(
      this.languageArray,
      this.selectedLanguage
    );

    this.currencyArray = this.partialRegistrationHelperService.getSelectedCurrency(
      this.currencyArray,
      this.selectedCurrency
    );

    // Log successful enhancement
    this.analyticsReady = true;
  }

  // End Enhancements component================================================
  private getLanguageName(code: string): string {
    const names = {
      'en': 'English',
      'fr': 'Français',
      'de': 'Deutsch',
      'es': 'Español',
      'it': 'Italiano',
      'pt': 'Português'
    };
    return names[code] || 'English';
  }
  private userStartedTyping(): boolean {
    if (!this.createAccountForm) return false;

    const fields = ['phoneNumber', 'password', 'email', 'voucher_code'];
    return fields.some(field => {
      const control = this.createAccountForm.get(field);
      return control && control.value && control.touched;
    });
  }
  private processNavigationParams(): void {
    const queryParams = { ...this.route.snapshot.queryParams };

    this.callFromPromotion = queryParams.call_from || '';
    this.gc = queryParams.gc || '';
    this.vc = queryParams.vc || '';
    this.tp1 = queryParams.TP1 || queryParams.tp1 || '';
    this.tp2 = queryParams.TP2 || queryParams.tp2 || '';
    this.tp3 = queryParams[Object.keys(queryParams).find(k => k.toLowerCase() === 'tp3')] || '';
    this.t_id = queryParams[Object.keys(queryParams).find(k => k.toLowerCase() === 't_id')] || '';
    this.other = queryParams.Other || queryParams.other || '';
    this.upsell_ID = queryParams.upsellID || queryParams.upsell_id || '';
    this.cje = queryParams.cjevent || '';
    this.pt = queryParams.pt || '';

    this.prosub_id = resolveProsubIdFromParamMap(this.route.snapshot.queryParamMap);
    this.setValuesGlobally();
    // Remove conflicting keys before sending to GTM
    delete queryParams['Prosub_ID'];
    delete queryParams['Prosub_id'];
    delete queryParams['prosub_id'];
    delete queryParams['prosub_ID'];

    this.GTMServise.queryParamsToNavigate = queryParams;


    if (this.cje) {
      this.AuthPartialRegService.setCJCookie(this.cje);
    }
  }
  private handleSessionReload(): void {
    const userId = this.partialRegistrationHelperService.getUserId(); // e.g., from localStorage or cookies
    const hasReloaded = sessionStorage.getItem('partialRegReloaded');
    const reloadCount = parseInt(sessionStorage.getItem('partialRegReloadCount') || '0', 10);

    // Block excessive reloads
    if (reloadCount > 2) {
      this.errorHandlerService.logError('Blocked repeated reloads during partial registration');
      return;
    }

    // If user ID exists but form is blank, reload once
    if (userId && !hasReloaded) {
      sessionStorage.setItem('partialRegReloaded', 'true');
      sessionStorage.setItem('partialRegReloadCount', (reloadCount + 1).toString());

      // Trigger reload
      location.reload();
    }
  }

  private async loadCriticalData(): Promise<void> {
    // 1. CRITICAL: Load route data FIRST - this sets up form validators without blocking on IP/API
    const routeData = this.route.snapshot?.data?.data;

    this.prosub_id = routeData?.prosubDetail?.prosub_id ||
      resolveProsubIdFromParamMap(this.route.snapshot.queryParamMap);

    // The resolver now returns { pending: true }. Apply the standard editable
    // form defaults in this active initialization path, then let applyOfferState
    // apply the actual offer's module configuration without clearing typed values.
    this.checkForModules(routeData?.modData || {
      email: true, msn: true, voucher: false, terms_condition: true,
    });

    // 2. Perform quick connection check to update online/offline status (non-blocking)
    try {
      const connection = await this.connectionManagerService.checkConnectionWithFallback();
      this.isOnline = connection.canProceed;
    } catch {
      this.isOnline = true; // Default to online if check fails
    }
  }

  /**
   * Comprehensive check for any App Check related errors
   */
  private isAppCheckRelatedError(error: Data): boolean {
    if (!error) return false;

    // Convert error to string for comprehensive checking
    const errorString = JSON.stringify(error).toLowerCase();

    // Check all possible App Check error indicators
    const appCheckIndicators = [
      'appcheck',
      'app-check',
      'app_check',
      '403 error',
      'initial-throttle',
      'throttled',
      'recaptcha',
      'firebase_appcheck',
      'x-firebase-appcheck',
      'token refresh',
      'token acquisition'
    ];

    return appCheckIndicators.some(indicator =>
      errorString.includes(indicator) ||
      error?.code?.toLowerCase()?.includes(indicator) ||
      error?.message?.toLowerCase()?.includes(indicator)
    );
  }

  /**
   * Wrap all Firebase operations to catch App Check errors
   */
  private async safeFirebaseOperation<T>(
    operation: () => Promise<T>,
    fallbackValue: T,
    context: string
  ): Promise<T> {
    try {
      return await operation();
    } catch (error) {
      if (this.isAppCheckRelatedError(error)) {
        this.authService.errorHandlerLogs(`[${context}] App Check related error detected - using fallback`, error);
        // Track for monitoring
        this.trackAppCheckError(context, error);
        return fallbackValue;
      }

      // Log other errors but still return fallback
      this.authService.errorHandlerLogs(`[${context}] Operation failed:`, error);
      return fallbackValue;
    }
  }

  private trackAppCheckError(context: string, error: Data): void {
    // Send to analytics for monitoring
    if ((window as Data).gtag) {
      (window as Data).gtag('event', 'app_check_error_after_removal', {
        context,
        error_type: error?.code || 'unknown',
        error_message: error?.message || 'unknown',
        timestamp: new Date().toISOString()
      });
    }
  }
  uploadUserFingerprintInfo() {
    this.commonService.getUid("authService").pipe(take(1)).subscribe({
      next: (uid) => {
        if (uid) {
          this.userManagementService.uploadUserFingerprintInfo(uid, CommonVariable.FingerprintJSConst);
        }
      }
    });
  }

}